import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DeviceInfo, DeviceNotificationType } from '../../shared/models/Device/DeviceInfo';
import { Device, DeviceMessageInfo, DeviceNotification, DeviceRegistration, DeviceRegistrationTrustInfo, VirtualDevice } from '../../shared/models/Device/Device';
import { DeviceService } from '../../shared/services/device.service';
import { ConfirmationService} from 'primeng/api';
import { UserGroup, SensorGroup, Event, TaskInfo, Sensor, SensorReadingType,
         DeviceCheckCriteria, DeviceStats, GatewayCommand, DeviceCamera, GatewayCommandCategoryDetails, DeviceLog, TimeZoneDisplay, 
         LastSensorReading,
         SensorSource,
         DeviceFunction} from '../../shared/models';
import { UserService } from '../../shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SensorGroupService } from '../../shared/services/sensorgroup.service';
import { SensorService } from '../../shared/services/sensor.service';
import { TimerRound } from '../../shared/models/Irrigation/timerRound';
import { WaterSchedule } from '../../shared/models/Irrigation/waterSchedule';
import { TriggerService } from '../trigger-settings/trigger.service';
import moment from 'moment';
import { AppComponent} from '../../app.component';
import { Task } from '../../shared/models/Device/Task.model';
import { GatewayInfo } from '../../shared/models/Device/GatewayInfo';
import { EventMapper } from '../trigger-settings/trigger.mapping';
import { AccessTaskParams } from '../../shared/models/Task/AccessTaskParams.model';
import { UserAccessType } from '../../shared/models/User/UserAccessType.model';
import { Message, MessageActionType, MessageType, AppComponentName } from '../../shared/models/Messages/message.model';
import { AppMessageService } from '../../shared/services/message.service';
import { ChartData } from '@models/Dashboard/chartData.model';
import { CommonShared } from 'app/shared/classes/common';
import { Authorization } from 'app/shared/classes/authorization';
import { ActivatedRoute } from '@angular/router';
import { SensorMapping } from 'app/shared/classes/sensorMapping';
import { DeviceMapping } from 'app/shared/classes/deviceMapping';
import { QuickCreateSensorgroupComponent, QuickCreateSensorgroupParams } from '../sensor-groups/quick-create-sensorgroup/quick-create-sensorgroup.component';
import { DateRanges } from '@models/ranges';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from '../messages/changelog-notes/changelognotes.components';
import { UpgradeManagerComponent, UpgradeManagerParams } from './upgrade-manager/upgrade-manager.component';
import { CloudFileStorage } from '@models/Device/CloudFileStorage.model';
import { FileStorageService } from '@services/fileStorage.service';
import { SensorDataModalComponent, SensorDataModalParams } from '../sensors/sensor-data-modal/sensor-data-modal.component';
import { SensorLabelComponent, SensorLabelModalParams } from '../sensors/sensor-label-modal/sensor-label-modal.component';
import { defer, EMPTY, forkJoin, from, Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { slice } from 'lodash';
import Timeout = NodeJS.Timeout;
import { SensorAssociationsModalComponent, SensorAssociationsParams } from '../sensors/sensor-associations-modal/sensor-associations-modal.component';
import { IrrigationStatsModalComponent, IrrigationStatsParams } from './irrigation-stats/irrigation-stats.component';
import { HubConnectionFactory } from '@services/hub-connection-factory.service';
import { HubConnectionState } from '@microsoft/signalr';

@Component({
  standalone: false,
  selector: 'app-register-devices',
  templateUrl: './register-devices.component.html',
  styleUrls: [ './register-devices.component.scss' ]
})

export class RegisterDevicesComponent implements OnInit {

  public common = new CommonShared();
  public auth = new Authorization();
  public sensorMapping = new SensorMapping();
  public deviceMapping = new DeviceMapping();

  modalDragOn: boolean = false;

  devices: Device[] = [];
  device: Device = {} as Device;

  public associatedUserGroups: UserGroup[] = [];
  public userGroups: UserGroup[] = [];
  public allSensorGroups: SensorGroup[] = [];
  public sensorGroupsDisplayed: SensorGroup[] = [];
  public events: Event[] = [];

  public selectedUserGroup: UserGroup;
  public registrationResults: VirtualDevice;

  // Virtual gateway security-registration token type: 'Es256' (compact, recommended) or 'Rsa' (legacy long token)
  public registrationTokenType: string = 'Es256';
  public registrationConfirmMessage: string = '';
  public registrationConfirmHeader: string = '';
  public registrationConfirmMode: 'new' | 'update' = 'new';
  public registrationConfirmDevice: Device;
  public registrationConfirmResultsTemplate: TemplateRef<any>;
  public registrationConfirmModalRef: BsModalRef;
  @ViewChild('registrationConfirmTemplate') registrationConfirmTemplate: TemplateRef<any>;

  public username = 'unknown';
  public awaitAssociatedUserGroups = false;
  public awaitSensorUUIDs = false;
  public awaitDevices = false;
  public visitedScan = false;
  public loadingCloudStorageFileList = false;
  public validIPAddress = false;
  public ipClickout = true;
  public duplicateIPAddress = false;
  public duplicateName = false;
  public duplicateSerial = false;
  public duplicateWaterSchedulename = false;

  public buttonValue: string;
  public irrigationButton: string;
  public title: string;
  public deletemessage: string;
  public hasBluetoothScan = false;
  public scannedSensor = '';
  public sensorSearch = '';
  public sensorGroupSearchText = '';
  public sensorToAdd: Sensor;
  public allSensors: Sensor[] = [];
  public gatewaySensorUUIDs: Sensor[] = [];
  public retrievingGatewaySensorInfo = false;
  public sensorUUIDsDisplayed: Sensor[] = [];
  public allSensorUUIDsDisplayed = false;
  public gatewayInfo: DeviceInfo = {} as DeviceInfo;
  public loadingHardwareInfo: boolean = false;
  public loadingSensorGroups: boolean = false;
  public scannedSensors: Sensor[] = [];
  public IPAddresses: string[] = [];
  public waterSchedule: TimerRound[];
  public devicesCheckedCount: number = 0;
  public selectedWaterSchedule: WaterSchedule;
  public selectedWaterScheduleIndex: number;

  public notifyNoDeviceResponse: DeviceNotification;
  public notifyNoSensorResponse: DeviceNotification;
  public notifyValueResponse: DeviceNotification;

  public globalWaterSchedules: WaterSchedule[] = [];

  public currentWaterScheduleUsage: string[] = [];
  public currentDevices: string[] = [];
  public currentDeviceID: number;
  public currentWaterScheduleID: number;
  public preEditObjectAsJSONString = '';
  public invalidDates: moment.Moment[] = [];
  public selectedDateRange: any;
  public irrigationLogs: DeviceLog[] = [];
  public systemLogs: DeviceLog[] = [];
  public deviceLogs: DeviceLog[] = [];
  public anyDeviceChecked = false;
  public startDate: Date;
  public endDate: Date;
  public logMode = '';
  public gatewayActivityLogCountToRetrieve: number = 10;
  public gatewayLogDateRange: any;
  public gatewayLogsLoading: boolean = false;   // show a spinner while a date-range fetch is in flight
  public awaitIrrigationLogs = false;
  public awaitSystemLogs = false;
  public addNewSensors: Sensor[] = [];
  public changeLogNotes = '';
  public sensorReadingTypes: SensorReadingType[] = [];
  public datatypesLoaded = false;

  public gatewayLiveCommand = '';
  public gatewayLiveCommandResults = '';
  public allGatewayCommands: GatewayCommand[];
  public gatewayCommands: GatewayCommand[];
  public gatewayCommandSelected: GatewayCommand = { name: '', description: '', category: '', command: '' };
  public userIsAdmin = false;
  public userCanUpdateGateway = false;
  public deviceFunctions: DeviceFunction[] = [];

  // Security-tab presets: each maps a gateway type to the API functions it enables,
  // keyed by function NAME so the mapping stays valid regardless of DeviceFunction id
  // ordering across environments. The chosen preset is NOT persisted -- only
  // device.deviceFunctionIds is -- so on edit the active preset is derived by comparing
  // the saved selection to these sets (see selectedGatewayPreset).
  public readonly customGatewayPresetLabel = 'Custom';
  public readonly gatewayFunctionPresets: { label: string; functionNames: string[] }[] = [
    { label: 'Basic Gateway', functionNames: [
      'UpdateDeviceIpAddressV2', 'BTSensorMacAddressPrefixesV2', 'PostUpdateMessageV2',
      'DeviceTrustCheck', 'GetTasksV2', 'CreateTaskV2', 'UpdateTaskV2', 'DownloadFileV2'
    ]},
    { label: 'Controller Gateway', functionNames: [
      'UpdateDeviceIpAddressV2', 'BTSensorMacAddressPrefixesV2', 'PostUpdateMessageV2',
      'DeviceTrustCheck', 'InvokeEventActionsV2', 'GetTasksV2', 'CreateTaskV2', 'UpdateTaskV2',
      'DownloadFileV2'
    ]},
    { label: 'Scoutview Gateway', functionNames: [
      'UpdateDeviceIpAddressV2', 'BTSensorMacAddressPrefixesV2', 'PostUpdateMessageV2',
      'DeviceTrustCheck', 'UploadFileV2', 'UploadImageV2', 'UploadThumbnailV2',
      'CreateMetadataV2', 'UpdateMetadataV2', 'GetTasksV2', 'CreateTaskV2', 'UpdateTaskV2',
      'DownloadFileV2'
    ]},
    // No bearer-token APIs enabled -- selecting this unchecks every function. Also
    // the derived label for a gateway saved with an empty selection.
    { label: '3rd Party Ingest Only', functionNames: [] }
  ];

  public QRLabelText = '';
  public QRCodeText = '';

  public uploadFileContent = '';
  public remoteContentReference = '';
  public remoteFileContentLoadCommands: string[] = [];
  public remoteFileContentSaveCommands: string[] = [];
  public remoteFileContentRestoreCommands: string[] = [];

  public userNameTimer: any;
  public waterScheduleNameChanges: WaterSchedule[] = [];

  public availableDevices: MediaDeviceInfo[];
  public selectedDevice: MediaDeviceInfo;

  selectedTimeZone: TimeZoneDisplay = TimeZoneDisplay.Local;
  selectedTimeZoneOffset: number = moment().utcOffset();
  
  availableCloudFiles: CloudFileStorage[] = [];
  selectedCloudFiles: CloudFileStorage[] = [];

  selectedFile: CloudFileStorage;
  showGatewayMessages: boolean = false;
  gatewayLogSearchText: string = '';

  public gatewaySearchText: string = "";
  public devicesDisplayed: Device[] = [];
  public searchRecallTimer?: Timeout;
  private aliveCheckTimer?: Timeout;

  public cloudStorageCols = [
    {field: 'checked', header: '', width: '3%'},
    {field: 'name', header: 'Name', width: '52%'},
    {field: 'uploadDate', header: 'Upload Date', width: '30%'},
    {field: 'downloadToGateway', header: '', width: '5%'},
    {field: 'downloadToDesktop', header: '', width: '5%'},
    {field: 'delete', header: '', width: '5%'}
  ];

  public DeviceCols = [
    {field: 'checked', header: '', width: '3%'},
    {field: 'name', header: 'Name', width: '13%'},
    {field: 'description', header: 'Description', width: '14%'},
    {field: 'registerDate', header: 'Register Date', width: '14%'},
    {field: 'owner', header: 'Device Owner', width: '15%'},
    {field: 'serialNumber', header: 'Serial #', width: '6%'},
    {field: 'aliveTimeStamp', header: 'Last Check-in', width: '12%'},
    {field: 'version', header: 'Version', width: '5%'},
    {field: 'trust', header: 'Trusted', width: '5%'},
    {field: 'ingest', header: 'IngestStats', width: '7%'},
    {field: 'edit', header: '', width: '3%'},
    {field: 'delete', header: '', width: '3%'}
  ];

  SensorGroupUUIDCols = [
    {field: 'checkbox', header: '', width: '3%'},
    {field: 'name', header: 'Name', width: '17%'},
    {field: 'uuid', header: 'UID', width: '37%'},
    {field: 'lastReadingDate', header: 'Last Reading', width: '24%'},
    {field: 'type', header: 'Type', width: '10%'},
    {field: 'sync', header: 'Sync', width: '9%'}
  ];

  ScannedSensorCols = [
    {field: 'name', header: 'Name', width: '20%'},
    {field: 'uuid', header: 'UID', width: '60%'},
    {field: 'type', header: 'Type', width: '20%'}
  ];

  IrrigationCols = [
    {field: 'name', header: 'Name', width: '25%'},
    {field: 'owner', header: 'Owner', width: '23%'},
    {field: 'cycles', header: 'Cycles', width: '9%'},
    {field: 'timeOn', header: 'Time On', width: '12%'},
    {field: 'timeOff', header: 'Time Off', width: '12%'},
    {field: 'usedByCount', header: 'Used', width: '9%'},
    {field: 'edit', header: '', width: '5%'},
    {field: 'delete', header: '', width: '5%'}
  ];

  public eventLogCols = [
    {field: 'date', header: 'Date'},
    {field: 'msg', header: 'Message'}
  ];

  public userGroupconfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select User Group',
    noResultsFound: 'No User Groups found!',
    searchOnKey: 'name'
  };

  public CameraDDConfig = {
    displayKey: 'name',
    search: false,
    height: '200px',
    limitTo: 0
  };

  public CameraTypeDDOptions: string[] = [ 'Line Power', 'Solar Power' ];
  public CameraModelDDOptions: string[] = [ 'Reolink PTZ', 'Reolink PTZ Dual Lens', 'Reolink Fixed Dual Lens', 'Reolink Fixed', 'ArduCam Fixed 16MP', 'ArduCam Fixed 12MP Wide NoIR', 'ArduCam Fixed 12MP Wide', 'ArduCam Fixed 64MP' ];

  public ranges = DateRanges;
  public scanModalRef: BsModalRef;
  public deviceChartModalRef: BsModalRef;
  modalRef: BsModalRef;
  firstlayermodalref: BsModalRef;
  secondlayermodalref: BsModalRef;
  logModalRef: BsModalRef;
  hwModalRef: BsModalRef;
  wsModalRef: BsModalRef;
  registrationResultsModalRef: BsModalRef;
  iotDirectModalRef: BsModalRef;
  sensorGroupsModalRef: BsModalRef;

  // Bulk Change (admin-only multi-device actions)
  public bulkChangeModalRef: BsModalRef;
  public bulkChangeAction: string = '';
  public bulkSelectedUserGroup: UserGroup;

  iotDirectHistory: string = '';
  iotDirectCommand: string = '';
  iotDirectWaitingForConnection: boolean = false;

  config = {
    backdrop: false,
    ignoreBackdropClick: true
  };

  popUpWSInfoConfig = {
    backdrop: false,
    ignoreBackdropClick: false
  };

  public globalSwitch: boolean;

  public chartData: ChartData[];
  public chartDataTypes: SensorReadingType[] = [];
  public chartName: string = "";
  public chartSensor: Sensor;
  public chartDays: number = 7;
  public chartView: any[] = [1200,700];
  public chartOptions: any = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    animations: false,
    showXAxisLabel: true,
    xAxisLabel: 'Date-Time (Select Range from the below Scale)',
    showYAxisLabel: true,
    yAxisLabel:'Value',
    autoScale: true,
    legendTitle:'Connectivity',
    timeline: true,
    yScaleMin: 0,
    yScaleMax: 1.2,
    colorScheme: {
      domain: [ '#046dd6', '#800080', '#42f55a', '#ffc107', '#fa0f0f' ]
    }
  };

  public btMacAddressPrefixes: { [key: string] : string };
  private hubConnection: signalR.HubConnection


  constructor(private deviceService: DeviceService, public toastr: ToastrService, public modalService: BsModalService, public _fileStorageService: FileStorageService,
              private confirmationService: ConfirmationService, public _userService: UserService, public _sensorService: SensorService, private hubFactory: HubConnectionFactory,
              public _sensorGroupService: SensorGroupService, private _triggerService: TriggerService, private global: AppComponent, public _appMessageService: AppMessageService,
              private route: ActivatedRoute) {

                this.globalSwitch = global.globalSwitch;
                this.linkedSearch = route.snapshot.queryParamMap.get('search');
                
                this.hubConnection = this.hubFactory.create('/api/hubs/gateway');
                this.hubConnection.onclose(error => console.log('hubConnection.onclose') );
                this.hubConnection.onreconnecting(error => console.log('Attempting reconnect...') );
                this.hubConnection.onreconnected(() => console.log('Reconnected.') );
                this.hubConnection.on('refreshGateway', (updateType: string, updateGateway: string) => this.refreshGateway(updateType, updateGateway));
              }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username != '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    this.startSignalR();
    this.device = this.buildNewDevice();
    this.gatewayInfo = this.deviceMapping.mapDevice2DeviceInfo(this.buildNewDevice());
    this.awaitSensorUUIDs = true;
    this.startTimer4DeviceAliveCheck();
    this.loadPageData();
  }


  // Loads what the gateway list needs in parallel, then the gateways. Everything only the edit dialog uses is requested
  // alongside the gateways but never blocks the table (see loadEditDialogData).
  private loadPageData(): void {
    forkJoin({
      associatedUserGroups: this._userService.getAssociatedUserGroups(this.username),
      userGroups: this._userService.getUserGroups(),
      sensorReadingTypes: this._sensorService.getSensorDatatypesWithIDs()
    }).subscribe(
      results => {
        if (results.associatedUserGroups == null) {
          return;
        }
        this.associatedUserGroups = results.associatedUserGroups;
        this.awaitAssociatedUserGroups = true;

        if (results.sensorReadingTypes != null) {
          this.sensorReadingTypes = results.sensorReadingTypes;
          this.common.sortArrayByTypeParm(this.sensorReadingTypes);
          this.datatypesLoaded = true;
        } else {
          this.toastr.warning('No datatypes found.');
        }

        if (results.userGroups == null) {
          this.toastr.warning('No user groups found');
          return;
        }
        this.userGroups = results.userGroups;
        const adminGroup = this.userGroups.find(x => x.name.toLowerCase() == "admins");
        if (adminGroup != undefined) {
          this.userIsAdmin = (adminGroup.userInfos.find(u => u.userName.toLowerCase() === this.username.toLowerCase()) != undefined) ? true : false;
        }

        this.getEvents();
        this.getDevices();
        this.loadEditDialogData();
      },
      err => {
        this.toastr.error('Error occurred while loading gateway page data.');
      });
  }


  private loadEditDialogData(): void {
    this.getGlobalSensorList();
    this.getGlobalWaterSchedules();
    this.getDeviceFunctions();
    this.loadGatewayQuickLinkCommands();
    this.getBtMacAddressPrefixes();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }

  
  private startSignalR(): Observable<any> {
    return (this.hubConnection.state === HubConnectionState.Disconnected) ? from(this.hubConnection.start()) : EMPTY;
  }

  public ngOnDestroy() {
    this.stopSignalR();
    clearInterval(this.aliveCheckTimer);
    clearTimeout(this.searchRecallTimer);
  }

  private stopSignalR() { this.hubConnection.stop(); }

  private refreshGateway(updateType: string, updateGateway: string) {
    //console.log(`refreshGateway: ${updateType} - ${updateGateway}`);

    if (updateType == 'iotDirect') {
      this.iotDirectHistory += updateGateway + '\n';
    }
  }


  startTimer4DeviceAliveCheck() {
    clearInterval(this.aliveCheckTimer);
    this.aliveCheckTimer = setInterval(() => {
      this.getDeviceAliveTimes();
    },45000);
  }


  getDeviceAliveTimes(): void {
    const accessTaskParams: AccessTaskParams = {
      deviceSerialNumber: 'all',
      taskType: 2
    };
    this.deviceService.getTasks(accessTaskParams).subscribe(
      results => {
        if (results != null) {
          if (results.length > 0) {
            const tasks: TaskInfo[] = results;
            tasks.forEach( t => {
              const id = this.devices.findIndex( d => d.id == t.deviceID);
              if (id >= 0) {
                this.devices[id].aliveTimeStamp = moment.utc(t.lastModifiedDate).toDate();
                this.devices[id].aliveColor = this.getDeviceAliveColor(this.devices[id].aliveTimeStamp);
              }
            });
          }
        } else {
        //this.toastr.warning('No device alive timestamps found.');
        }
        return;
      },
      err => {
      //this.toastr.error('Error retrieving alive tasks from cloud.');
      });
  }


  addWSrow(waterSchedule: WaterSchedule): void {
    waterSchedule.timerRounds.push({id: waterSchedule.timerRounds[waterSchedule.timerRounds.length - 1].id + 1, on: 1, off: 0, multiplier: 1});
    this.selectedWaterSchedule = waterSchedule;
  }


  deleteWSrow(waterSchedule: WaterSchedule, i: number): void {
    waterSchedule.timerRounds.splice(i,1);
    this.selectedWaterSchedule = waterSchedule;
  }


  getCheckedSensorUUIDs(): number {
    if (this.sensorUUIDsDisplayed == null) return 0;

    return this.sensorUUIDsDisplayed.filter(s => s.checked).length; 
  }


  revertUUIDsBack(): void {
    this.updateGlobalSensorUUIDsUsingDeviceSensorUUIDs(this.device);
    this.hasBluetoothScan = false;
  }


  sendScript_scanReturnRaw_ToDevice() {
    var fileContentArray: string [] = [
      "#!/bin/bash",
      "cd /home/pi/kigs/scripts/tasks",
      "sudo hciconfig hci0 down; sleep 3",
      "sudo hciconfig hci0 up; sleep 3",
      "btScanList=`sudo timeout -s 9 20 stdbuf -oL /usr/bin/hcitool lescan`",
      "echo -n \"$btScanList\"",
      "exit 0"
    ];
    this.gatewayLiveCommandResults = '';
    this.sendFileToDevice(fileContentArray.join('\n'), "/home/pi/kigs/scripts/tasks/scanReturnRAW.sh", true);
  }


  sendFile_IDWhoAmI_ToDevice(device: Device) {
    var fileContentArray: string [] = [
      `name: ${device.name}`,
      `lat: ${device.gpsLocation.gpsLat}`,
      `long: ${device.gpsLocation.gpsLong}`,
      `alt: ${device.gpsLocation.gpsAlt}`,
      `serial: ${device.serialNumber}`,
      `macAddress: ${device.macAddress}`,
      `mountAngle: ${device.mountAngle}`
    ];
    this.gatewayLiveCommandResults = '';
    this.sendFileToDevice(fileContentArray.join('\n'), "/home/pi/kigs/ID.WhoAmI", false);
  }


  sendFile_SensorList_ToDevice(device: Device) {
    var fileContentArray: string [] = [];
    device.sensorUUIDs.forEach(x => {
      var macAddress = this.common.extractMacAddressFromUUID(x);
      var sensor = this.sensorUUIDsDisplayed.find(y => y.uuid == x);
      var sensorType = (sensor != undefined) ? sensor.type.toLowerCase() : '';
      fileContentArray.push( `${macAddress} name ${sensorType}` );
    });
    this.gatewayLiveCommandResults = '';
    this.sendFileToDevice(fileContentArray.join('\n'), "/home/pi/kigs/scripts/cron/sensor.list", false);
  }


  removeFile_KIGsBatchDynamic_FromDevice(device: Device) {
    this.executeLiveCommand(null, '/usr/bin/rm /home/pi/kigs/scripts/cron/kigs-batch.dynamic', '', 'Removing dynamic sensor mode ...');
  }


  sendFile_KIGsBatchDynamic_ToDevice(device: Device) {
    this.executeLiveCommand(null, '/usr/bin/touch /home/pi/kigs/scripts/cron/kigs-batch.dynamic', '', 'Setting static sensor mode ...');
  }


  bluetoothScan_ReturnRaw(deviceID: number, mode: string, template: TemplateRef<any>) {
    if (mode == null || mode == '') {
      this.toastr.error('Please select mode before scanning');
    }
    else {
      this.scannedSensors = [];

      const task = this.buildNewTask(deviceID, '/home/pi/kigs/scripts/tasks/scanReturnRAW.sh', '');

      this.deviceService.postTask(task, 'Gateway scanning for bluetooth sensors', 4).subscribe(
        results => {
          if (results != null && results != '') {

            this.addNewSensorMacAddresses(results);

            this.scannedSensors = this.convertGwBtRawScanResultsToSensors(results);

            this.hasBluetoothScan = true;

            this.scannedSensors.forEach(x => {
              const sensorInDatabase = this.allSensors.find(u => u.uuid.toUpperCase() == x.uuid.toUpperCase());

              if (sensorInDatabase != null) {
                var isSensorAlreadyDisplayed = this.sensorUUIDsDisplayed.find(y => y.id == sensorInDatabase.id);
                if (isSensorAlreadyDisplayed == undefined) {
                  this.sensorUUIDsDisplayed.push(sensorInDatabase);
                }
              }
              else {
                var newSensor: Sensor = {
                  id: 0,
                  sensorReadingTypes: null,
                  checked: true,
                  uuid: x.uuid,
                  modifiedDate: new Date(),
                  sensorReadingTypeNames: '',
                  userName: this.username,
                  userGroupId: null,
                  name: x.name,
                  type: x.type,
                  virtualSensor: undefined,
                  lastReading: { sensorId: x.id, isLoaded: false, date: null, displayColor: "black", waitingForLoad: false },
                  sensorCalibrationHistory: null,
                }
                this.allSensors.push(newSensor);
                this.addNewSensors.push(newSensor);
              }
            });

            //this.buildSensorUUIDDisplayList(this.allSensorUUIDsDisplayed);
            this.updateSensorNameAndType(this.sensorUUIDsDisplayed);
            this.sensorUUIDsDisplayed.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? 1 : -1);
            this.getLastSensorReadingDatesForSensors(this.sensorUUIDsDisplayed);

            if (this.device.mode == 'dynamic') {
              this.secondlayermodalref = this.modalService.show(template, this.config);
            }
          } else {
            this.toastr.warning('No Sensors within range of gateway');
          }

          return;
        },
        err => {
          this.toastr.error('Error occurred while retrieving sensors.');
        });
    }
  }


  addNewSensorMacAddresses(btScanResultsRaw: string) {
    var btScanResults = this.convertGwBtRawScanResultsToDict(btScanResultsRaw);
    var newBtMacAddresses = this.findNewBtMacAddressPrefixes(btScanResults);

    if (newBtMacAddresses == null || Object.keys(newBtMacAddresses).length < 1) {
      return;
    }

    this.btMacAddressPrefixes = {...this.btMacAddressPrefixes, ...newBtMacAddresses};   // Update local list
    this.addBtMacAddressPrefixesToServer(newBtMacAddresses);                            // Update server list on db
  }


  findNewBtMacAddressPrefixes(macAddressesAsDict: { [key: string] : string }): { [key: string] : string } {    // actually just looking for sensorpushes and mifloras at this time
    var newBtMacAddresses: { [key: string] : string } = { };

    for (const [key, value] of Object.entries(macAddressesAsDict)) {
      if (value.toLowerCase() == 'sensorpush' || value.toLowerCase() == 'miflora') {
        var fullKey = key.replace(/:/g, '');
        
        if (newBtMacAddresses[fullKey] == undefined && value != undefined && fullKey.length > 7) {
          var shortKey = fullKey.substring(0, 6);
          newBtMacAddresses[shortKey] = value;
        }
      }
    }

    return newBtMacAddresses;
  }


  addBtMacAddressPrefixesToServer(newBtMacAddresses: { [key: string] : string }) {
    this._sensorService.addBtMacAddressPrefixes(newBtMacAddresses).subscribe(
      results => {
        if (results != null) {
          this.toastr.success('New sensor(s) detected. Server mac prefixes updated.')
        } else {
          this.toastr.warning('New sensor(s) detected, but wasn\'t able to update mac prefixes on the server');
        }
        return;
      },
      err => {
        this.toastr.error('New sensor(s) detected, but error occurred while adding mac prefixes to the server');
      });
  }


  convertGwBtRawScanResultsToDict(btScanResultsRaw: string): { [key: string] : string } {
    var macAddressesAsDict: { [key: string] : string } = { };

    var btScanResults = btScanResultsRaw.split('\n');
    btScanResults = [...new Set(btScanResults)];

    btScanResults.forEach(x => {
      var line = x.split(" ");

      if (line != undefined && line.length > 0 && line[0].length >= 17 ) {
        var macAddress = line[0];
        var label = (line.length > 1) ? line[1] : '';

        label = (label.toLowerCase() == 'flower') ? 'Miflora' : label;

        if (macAddressesAsDict[macAddress] == undefined || macAddressesAsDict[macAddress] == '(unknown)') {
          macAddressesAsDict[macAddress] = label;
        }
      }
    });

    return macAddressesAsDict;
  }


  convertGwBtRawScanResultsToSensors(btScanResultsRaw: string): Sensor[] {
    var sensors: Sensor[] = [];

    var btScanResults = btScanResultsRaw.split('\n');
    btScanResults = [...new Set(btScanResults)];

    // Govee is recognized by its advertised name only (no mac prefix lookup), and a mac seen as Govee on any line is Govee on all of them
    var goveeMacAddresses = new Set<string>();
    btScanResults.forEach(x => {
      var line = x.split(" ");

      if (line.length > 1 && line[0].length >= 17 && line.slice(1).join(' ').toLowerCase().includes('govee')) {
        goveeMacAddresses.add(line[0].toUpperCase());
      }
    });

    btScanResults.forEach(x => {
      var line = x.split(" ");

      if (line != undefined && line.length > 0 && line[0].length >= 17 ) {
        var macAddress = line[0];
        var sensorUUID = '';
        var sensorType = '';
        var sensorName = '';
        var scanLabel = line.slice(1).join(' ').toLowerCase();

        var sensorSerial = '';
        line.forEach(z => {
          if (z.startsWith('serial=') && z.length > 7) {
            sensorSerial = z.split('=')[1];
          }
        });

        sensorUUID = this.common.generateUUID_FromMacAddressAndSerial(macAddress, sensorSerial);
        if (goveeMacAddresses.has(macAddress.toUpperCase())) {
          sensorType = 'Govee';
          var goveeMac = sensorUUID.slice(-12).toUpperCase();
          sensorName = 'G-' + goveeMac.slice(6,8) + ':' + goveeMac.slice(8,10) + ':' + goveeMac.slice(10,12);
        }
        else {
          sensorType = this.common.extractTypeFromUUID(sensorUUID, this.btMacAddressPrefixes);
          sensorName = this.common.extractNameFromUUID(sensorUUID, this.btMacAddressPrefixes);

          if (sensorType == 'unknown') {
            if (scanLabel.includes('guardian')) {
              sensorType = 'Guardian';
            }
            else if (scanLabel.includes('flower') || scanLabel.includes('miflora')) {
              sensorType = 'Miflora';
            }
            else if (scanLabel.includes('sensorpush')) {
              sensorType = 'SensorPush';
            }
          }
        }

        if (sensorType != 'unknown' && !sensors.some(s => s.uuid == sensorUUID)) {
          var sensor: Sensor = {
            id: 0,
            uuid: sensorUUID,
            sensorReadingTypes: [],
            sensorReadingTypeNames: '',
            checked: false,
            modifiedDate: undefined,
            userGroupId: 0,
            userName: '',
            name: sensorName,
            type: sensorType,
            virtualSensor: undefined,
            sensorCalibrationHistory: null,
          };

        sensors.push(sensor);
        }
      }
    });

    return sensors;
  }


  verifyScannedSensorsHaveBeenCategorized(scannedSensors: Sensor[]): Sensor[] {
    if (scannedSensors == undefined || scannedSensors.length < 1) {
      return;
    }

    var verifiedSensors: Sensor[] = [];

    scannedSensors.forEach(x => {
      x.name = this.common.extractNameFromUUID(x.uuid, this.btMacAddressPrefixes);
      x.type = this.common.extractTypeFromUUID(x.uuid, this.btMacAddressPrefixes);

      if (x.name != undefined && x.name != '') {
        verifiedSensors.push(x);
      }
    });

    return verifiedSensors;
  }


  getGlobalSensorList(): void {
    this.allSensors = [];
    this._sensorService.getAllSensorsWithoutTypes().subscribe(
      results => {
        if (results != null) {
          this.allSensors = results;
          this.allSensors.forEach(x => {
            x.lastReading = { sensorId: x.id, isLoaded: false, date: null, displayColor: "black", waitingForLoad: false };
          });
          this.awaitSensorUUIDs = true;
        } else {
          this.toastr.warning('No sensors found on server');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor list');
      });
  }


  getBtMacAddressPrefixes(): void {
    this.btMacAddressPrefixes = { };
    this._sensorService.getBtMacAddressPrefixes().subscribe(
      results => {
        if (results != null) {
          this.btMacAddressPrefixes = results;
        } else {
          this.toastr.warning('No bluetooth mac address prefixes found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving bluetooth mac address prefixes');
      });
  }

  
  showSensorLabelModal(uuid: string): void {
    const params: SensorLabelModalParams = {
      uuid: uuid,
      btMacAddressPrefixes: this.btMacAddressPrefixes
    };

    this.modalService.show(SensorLabelComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  getGlobalWaterSchedules(): void {
    this.deviceService.getGlobalWaterSchedules().subscribe(
      results => {
        if (results != null) {
          this.globalWaterSchedules = (results.length != 0) ? this.deviceMapping.mapWaterScheduleInfos2WaterSchedules(results) : [];
        }
      },
      err => {
        this.toastr.error('Error occurred while retrieving irrigation schedule data from the server.');
      });
  }


  getFormattedDate(date: Date): string{
    const utcdate = moment.utc(date).format('YYYY-MM-DD HH:mm');
    const stillUtc = moment.utc(utcdate).toDate();
    const local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm');
    return local;
  }


  loadGatewayQuickLinkCommands() {
    this.deviceService.loadGatewayQuickLinkCommands().subscribe(
      results => {
        if (results != null) {
          this.allGatewayCommands = results;
        } else {
          this.toastr.warning('No gateway quick link commands found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving gateway quick link commands.');
      });
  }


  parseAndFilterGatewayCommands(): GatewayCommand[] {
    var filteredGatewayCommands: GatewayCommand[] = [];

    (this.allGatewayCommands ?? []).forEach(x => {

      try {
        var categoryDetails: GatewayCommandCategoryDetails = JSON.parse(x.category);

        if (categoryDetails.name.toLowerCase() == "scoutview") {
          var haveTypeOfScoutview = this.device.deviceCameras.filter(y => y.type.toLowerCase() == categoryDetails.type.toLowerCase());
          if (haveTypeOfScoutview != undefined && haveTypeOfScoutview.length > 0) {
            var command:GatewayCommand = {
              name: x.name,
              description: x.description,
              category: categoryDetails.name,
              command: x.command
            };
            filteredGatewayCommands.push(command);
          }
        }
      }

      catch (error) {
        var command:GatewayCommand = JSON.parse(JSON.stringify(x));
        filteredGatewayCommands.push(command);
      }

    });

    return filteredGatewayCommands;
  }


  getDevices(): void{
    this.deviceService.getDevices().subscribe(
      results => {
        if (results != null) {
          this.devices = this.deviceMapping.mapDeviceInfos2Devices(results, this.sensorReadingTypes);
          //this.common.sortArrayByNameParm(this.devices);

          this.devices.forEach(d => this.enrichDevice(d));

          this.userCanUpdateGateway = this.devices.some(d => d.userFeatureAccess?.['EditDevice'] === true);

          this.awaitDevices = true;
          this.loadDeviceStats(this.devices);
          this.startTimer4RecallLastSearchFilter();
        } else {
          this.toastr.warning('No gateway devices found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving gateways.');
      });
  }


  // Adds the page-only values that aren't part of the server's gateway data
  private enrichDevice(d: Device): void {
    this.auth.mapUserAccessForDevice(d, this.globalSwitch, this.username, this.userGroups);
    d.owner = this.getOwnerName(d);
    d.version = '*';

    d.trustInfo = new DeviceRegistration();
    d.trustInfo.expireDays = 3650;

    if (d.deviceCameras == undefined) {
      d.deviceCameras = [];
    }
  }


  // Requests the live status values for the given gateways (registration, alive, connectivity, ingest)
  private loadDeviceStats(devices: Device[]): void {
    if (devices.length < 1) {
      return;
    }
    this.getRegistrationInfoForDevices(devices.map(x => x.serialNumber));
    this.getDeviceAliveTimes();
    this.getDeviceConnectivityStats(devices);
    this.getDeviceIngestStats(devices.map(x => x.id));
  }


  // Fetches only the given gateways from the server and swaps them into the page list and the DeviceService cache
  private refreshDevicesById(ids: number[], onDone?: () => void): void {
    const uniqueIds = [...new Set(ids)].filter(id => id > 0);
    if (uniqueIds.length < 1) {
      onDone?.();
      return;
    }

    forkJoin(uniqueIds.map(id => this.deviceService.getDevice(id))).subscribe(
      results => {
        const refreshed: Device[] = [];

        results.forEach(info => {
          if (info == null) {
            return;
          }

          const device = this.deviceMapping.mapDeviceInfo2Device(info, this.sensorReadingTypes);
          this.enrichDevice(device);

          const index = this.devices.findIndex(d => d.id == device.id);
          if (index > -1) {
            // Keep the values this page already has until the fresh stats arrive
            const old = this.devices[index];
            device.checked = old.checked;
            device.aliveTimeStamp = old.aliveTimeStamp;
            device.aliveColor = old.aliveColor;
            device.connectivity = old.connectivity;
            device.ingestStats = old.ingestStats;
            device.trustInfo = old.trustInfo;
            this.devices[index] = device;
          } else {
            this.devices.push(device);
          }

          this.deviceService.upsertCachedDevice(info);
          refreshed.push(device);
        });

        this.common.sortArrayByNameParm(this.devices);
        this.afterDeviceListChanged();
        this.loadDeviceStats(refreshed);
        onDone?.();
      },
      err => {
        // Never leave the page showing stale data; fall back to loading everything
        this.toastr.warning('Could not refresh the saved gateway; reloading all gateways.');
        this.reloadAllDevices();
        onDone?.();
      });
  }


  private afterDeviceListChanged(): void {
    this.userCanUpdateGateway = this.devices.some(d => d.userFeatureAccess?.['EditDevice'] === true);
    this.searchGatewaysTextChanged();
  }


  // Removes deleted gateways from the page list and the cache. Their owned irrigation schedules are deleted
  // on the server too, so that list is the only other thing that has to be refreshed.
  private removeDevicesLocally(ids: number[]): void {
    this.devices = this.devices.filter(d => !ids.includes(d.id));
    ids.forEach(id => this.deviceService.removeCachedDevice(id));
    this.deviceService.clearWaterSchedulesCache();
    this.getGlobalWaterSchedules();
    this.afterDeviceListChanged();
  }


  private reloadAllDevices(): void {
    this.awaitDevices = false;
    this.deviceService.clearCachedVariables();
    this.getDevices();
    this.getGlobalWaterSchedules();
  }


  getDeviceConnectivityStats(devicesToCheck: Device[] = this.devices) {
    var forkJoinServices: any[] = [];
    var groupSize = 5;
    var groupCount = Math.ceil(devicesToCheck.length / groupSize);

    for (var count = 0; count < groupCount; count++) {
        var endRange = (count + 1) * groupSize;
        if (endRange > devicesToCheck.length) {
          endRange = devicesToCheck.length;
        }

        var subSetDevices = slice(devicesToCheck, count * groupSize, endRange);

        var dataCriteria: DeviceCheckCriteria = {
          pastNumberOfHoursToEvaluate: 24,
          deviceIds: subSetDevices.map(x => x.id)
        }
        forkJoinServices.push( this.deviceService.getDeviceConnectivityStats(dataCriteria) );
    }

    if (forkJoinServices.length < 1) {
      return;
    }

    forkJoin(forkJoinServices).subscribe(
      results => {
        results.forEach(result => {
          var stats: DeviceStats[] = result;
          var deviceIds = [...new Set(stats.map(x => x.id))];

          deviceIds.forEach(id => {
            var device = this.devices.find(device => device.id == id);
            if (device != undefined) {
              device.connectivity = stats.filter(y => y.id == device.id);
            }
          });
        });
        devicesToCheck.forEach(x => {
          x.connectivity.forEach(y => y.color = this.getDeviceConnectivityColor(y.value));
        });
    });
  }


  getRegistrationInfoForDevices(deviceSerialNumbers: string[]) {
    this.deviceService.getRegistrationInfoForDevices(deviceSerialNumbers).subscribe(
      results => {
        if (results != null) {
          var registrationInfos: DeviceRegistration[] = results;

          registrationInfos.forEach(x => {
            var index = this.devices.findIndex(d => d.serialNumber == x.serialNumber);
            x.expireDays = this.calcRegistrationExpireDays(x);
            if (index > -1) {
              this.devices[index].trustInfo = x;
            }
          });
        } else {
          this.toastr.warning('No device registration info found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving device registration info.');
      });
  }


  calcRegistrationExpireDays(deviceRegistration: DeviceRegistration): number {
    var days = 3650;
    days = (deviceRegistration.isVirtual) ? moment(deviceRegistration.expireDate).diff(moment(),'days') : 3650;
    days = (days < 0) ? 0 : days;
    return days;
  }


  getDeviceIngestStats(deviceIds: number[]) {
    var dataCriteria: DeviceCheckCriteria = {
      pastNumberOfHoursToEvaluate: 4,
      deviceIds: deviceIds  //this.devices.map(x => x.id)
    }

    // Clear current ids to indicated a click happended
    deviceIds.forEach(x => {
      var device = this.devices.find(y => y.id == x);
      if (device != undefined) {
        device.ingestStats = [];
      }
    });

    this.deviceService.getDeviceIngestStats(dataCriteria).subscribe(
      results => {
        if (results != null) {
          var stats: DeviceStats[] = results;
          this.devices.forEach(x => {
            var deviceStats = stats.filter(y => y.id == x.id);
            if (deviceStats != undefined && deviceStats.length > 0) {
              x.ingestStats = deviceStats;
            }
          });
        } else {
          this.toastr.warning('No gateway ingest stats info found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving gateway ingest stats info.');
      });
  }


  onDeleteConfirm(device) {
    const triggerNames: string[] = [];

    device.waterSchedules.forEach(ws => {
      if (ws.isSelfOwned) {
        const triggers = this.eventConditionsUsingWaterSchedule(ws);
        triggers.forEach(t => triggerNames.push(t));
      }
    });

    if (triggerNames.length != 0) {
      this.deletemessage = 'This device owns one or more irrigation schedules that are being using in the following Event & Actions.\n[ ' + triggerNames.join(', ') + ' ]\n.If you continue to delete, these irrigations will not occour. Please cancel and manually select a new irrigation schedule owner.\n\nAre you sure you want to delete the '+device.name+ ' schedule?';
    } else {
      this.deletemessage = 'Are you sure you want to delete device ' + device.name + '?';
    }

    this.confirmationService.confirm({
      message: this.deletemessage,
      key: 'cd1',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deviceService.removeDevice(device.id, this.username).subscribe(
          results => {
            if (results!=null) {
              this.createMessageData(MessageActionType.Deleted, device, '');
              this.removeDevicesLocally([device.id]);
              this.toastr.success('Delete Success');
            } else {
              this.toastr.warning('No device found.');
            }
            return;
          },
          err => {
            this.toastr.error('Error occurred while deleting device.');
          });
      },
      reject: () => {
      }
    });
  }


  getEvents(){
    this._triggerService.getEvents('Loading events ...').subscribe(
      results => {
        if (results != null) {
          const eventMapper = new EventMapper();
          this.events = eventMapper.mapEventInfos2Events(results);
          this.events.forEach(e => {
            this.updateEventUserAccess(e);
          });
        }
        else {
          this.toastr.warning('No Events & Actions found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving events.');
      });
  }


  updateEventUserAccess(event: Event) {
    if (event.userGroupID != null) {
      const userGroup = this.associatedUserGroups.find(u => u.id === event.userGroupID);
      if (userGroup) {
        event.userAccess = UserAccessType.ReadWrite;
        event.userGroup = userGroup.name;
        return;
      } else {
        event.userAccess = UserAccessType.Read;
        const otherUserGroup = this.userGroups.find(u => u.id === event.userGroupID);
        event.userGroup = (otherUserGroup != null) ? otherUserGroup.name : 'unknown';
        return;
      }
    }

    if (event.userName == this.username) {
      event.userAccess = UserAccessType.ReadWrite;
      return;
    }

    event.userAccess = UserAccessType.Read;
  }


  updateDeviceSensorListFromCheckedGlobalList(device: Device) {
    if(device.mode == 'static') {
      device.sensorUUIDs = this.sensorUUIDsDisplayed.filter(s => s.checked==true).map(s => s.uuid);
    }
  }


  updateDeviceWaterScheduleListFromEditedGlobalList(device: Device) {
    device.waterSchedules = [];
    const newOrEnabledWaterSchedules = this.globalWaterSchedules.filter(ws => (ws.isEnabled || ws.isSelfOwned) && ws.ownerID == device.id);
    newOrEnabledWaterSchedules.forEach(ws => {
      device.waterSchedules.push(ws);
    });
  }


  updateDevice(): void {
    if (this.duplicateName) {
      this.toastr.error('Gateway name is already being used or contains spaces or colons');
      return;
    }

    if (this.duplicateSerial) {
      this.toastr.error('Gateway serial# is already being used, too short, or contains special characters');
      return;
    }

    if(this.device.id < 1) {
      this.onCreateSave(this.device);
    }
    else {
      const original: Device = JSON.parse(this.preEditObjectAsJSONString);
      this.onEditSave(this.device);
    }
  }


  onEditSave(device: Device) {
    this.hasBluetoothScan=false;
    this.firstlayermodalref.hide();
    this.device.ipAddress = this.device.ipAddress.trim();

    if (this.selectedUserGroup.id > -1) {
      device.userGroupId = this.selectedUserGroup.id;
      device.userGroup = this.selectedUserGroup.name;
    }

    const newSensors$ = this.addNewSensorsToDatabase();
    const ownerUpdates$ = this.updateWaterScheduleOwners(device);
    this.updateCameraSettings(device);

    this.notifyValueResponse.sensorDataType = this.deviceMapping.getReadingTypeFromID(this.notifyValueResponse.sensorDataType.id, this.sensorReadingTypes);

    this.updateDeviceSensorListFromCheckedGlobalList(device);
    this.updateDeviceWaterScheduleListFromEditedGlobalList(device);
    this.updateDeviceNotificationRemoveNulls(device.deviceNotifications);
    this.mapLocalNotifications2DeviceNotifications(device.deviceNotifications);
    const deviceInfo = this.deviceMapping.mapDevice2DeviceInfo(device);

    // New sensors are created first so the gateway save finds them; other gateways whose irrigation schedule owner changed are saved last
    newSensors$.pipe(
      switchMap(sensorsAdded => this.deviceService.updateDevice(deviceInfo, this.username).pipe(map(results => ({ sensorsAdded, results }))))
    ).subscribe(({ sensorsAdded, results }) => {
      if (results!=null) {
        this.createMessageData(MessageActionType.Edited, device, this.getEditChanges(device));

        if (this.device.serialNumber != '' && this.gatewayDeviceChanges(device)) {
          this.sendFile_IDWhoAmI_ToDevice(device);
          this.sendFile_SensorList_ToDevice(device);
          if (device.mode == 'static') {
            this.removeFile_KIGsBatchDynamic_FromDevice(device);
          }
          else {
            this.sendFile_KIGsBatchDynamic_ToDevice(device);
          }
          //this.updateGatewayInfo();
        }

        ownerUpdates$.subscribe(ownerDeviceIds => {
          this.refreshAfterSave([device.id, ...ownerDeviceIds], sensorsAdded);
          this.toastr.success('Successfully updated device properties');
        });
      } else {
        this.toastr.warning('Could not update device properties.');
      }
    },
    err => {
      this.toastr.error('Error occurred while updating device properties.');
    });
  }


  // Brings the page and caches up to date after a save by refetching only the gateways that changed. Irrigation schedule ids can change
  // on the server whenever a gateway is saved, so that list is always refetched.
  private refreshAfterSave(deviceIds: number[], sensorsAdded: boolean): void {
    this.deviceService.clearWaterSchedulesCache();
    this.getGlobalWaterSchedules();

    if (sensorsAdded) {
      this.getGlobalSensorList();
    }

    this.refreshDevicesById(deviceIds);
  }


  onCreateSave(device: Device){
    this.hasBluetoothScan=false;
    this.firstlayermodalref.hide();
    this.device.ipAddress = this.device.ipAddress.trim();

    if(this.selectedUserGroup.id > -1) {
      device.userGroupId = this.selectedUserGroup.id;
      device.userGroup = this.selectedUserGroup.name;
    }

    const newSensors$ = this.addNewSensorsToDatabase();
    const ownerUpdates$ = this.updateWaterScheduleOwners(device);
    this.updateCameraSettings(device);

    this.notifyValueResponse.sensorDataType = this.deviceMapping.getReadingTypeFromID(this.notifyValueResponse.sensorDataType.id, this.sensorReadingTypes);

    this.updateDeviceSensorListFromCheckedGlobalList(device);
    this.updateDeviceWaterScheduleListFromEditedGlobalList(device);
    this.updateDeviceNotificationRemoveNulls(device.deviceNotifications);
    this.mapLocalNotifications2DeviceNotifications(device.deviceNotifications);
    const deviceInfo = this.deviceMapping.mapDevice2DeviceInfo(device);

    newSensors$.pipe(
      switchMap(sensorsAdded => this.deviceService.addDevice(deviceInfo).pipe(map(results => ({ sensorsAdded, results }))))
    ).subscribe(
      ({ sensorsAdded, results }) => {
        if (results!=null) {
          this.createMessageData(MessageActionType.New, device, '');
          if (this.device.serialNumber != '') {
            this.sendFile_IDWhoAmI_ToDevice(device);
            this.sendFile_SensorList_ToDevice(device);
            if (device.mode == 'static') {
              this.removeFile_KIGsBatchDynamic_FromDevice(device);
            }
            else {
              this.sendFile_KIGsBatchDynamic_ToDevice(device);
            }
            //this.updateGatewayInfo();
          }

          // The API returns the new gateway's id
          const newDeviceId = Number(results);

          ownerUpdates$.subscribe(ownerDeviceIds => {
            if (Number.isFinite(newDeviceId) && newDeviceId > 0) {
              this.refreshAfterSave([newDeviceId, ...ownerDeviceIds], sensorsAdded);
            } else {
              this.reloadAllDevices();
            }
            this.toastr.success('Successfully created device');
          });
        } else {
          this.toastr.warning('Could not create device.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while creating device.');
      });
  }


  updateCameraSettings(device: Device) {
    if (device.deviceCameras == undefined || device.deviceCameras.length < 1) {
      return;
    }

    device.deviceCameras.forEach(x => {
      if (x.type.toLowerCase().includes('solar')) {
        x.power = "solar";
      }
      else {
        x.power = "power";
      } 
    });
  }


  // Creates the sensors added in the dialog. Nothing is sent until the returned observable is subscribed; it emits true when sensors were created.
  addNewSensorsToDatabase(): Observable<boolean> {
    if (this.addNewSensors.length < 1) {
      return of(false);
    }

    const sensorInfosToUpdate = this.sensorMapping.mapSensors2SensorInfos(this.addNewSensors);

    return defer(() => this._sensorService.createSensor(sensorInfosToUpdate)).pipe(
      map(results => {
        if (results != null && results.length > 0) {
          this.toastr.success('New Sensors added successfully');
          this.addNewSensors = [];
          return true;
        }
        this.toastr.warning('Error in adding new sensors');
        return false;
      }),
      catchError(() => {
        this.toastr.warning('Error in adding new sensors');
        return of(false);
      }),
      tap(() => this._sensorService.clearCachedVariables())
    );
  }


  // Moves the changed irrigation schedules onto their new owner gateways. The gateways are updated in memory right away; the saves are
  // sent when the returned observable is subscribed and it emits the ids of the gateways that were saved.
  updateWaterScheduleOwners(device: Device): Observable<number[]> {
    const ownerSaves: Observable<number>[] = [];

    this.globalWaterSchedules.forEach(ws => {
      if (ws.ownerChanged && ws.ownerID != device.id) {
        const changedDevice = this.devices.find(d => d.id == ws.ownerID);

        if (changedDevice != null) {
          this.updateDeviceWithWaterSchedule(changedDevice, ws);
          const changedDeviceInfo = this.deviceMapping.mapDevice2DeviceInfo(changedDevice);

          ownerSaves.push(defer(() => this.deviceService.updateDevice(changedDeviceInfo, this.username)).pipe(
            tap(results => {
              if (results!=null) {
                this.toastr.success('Successfully updated waterschedule owner for ' + changedDevice.name);
              } else {
                this.toastr.warning('Could not update device waterschedule owner.');
              }
            }),
            catchError(() => {
              this.toastr.error('Error occurred while updating device properties.');
              return of(null);
            }),
            // Refresh the gateway even when its save failed so the page shows what the server has
            map(() => changedDevice.id)
          ));
        }
      }
    });

    return ownerSaves.length > 0 ? forkJoin(ownerSaves) : of([]);
  }


  updateDeviceWithWaterSchedule(device: Device, waterSchedule: WaterSchedule) {
    const wsIndex = device.waterSchedules.findIndex(ws => ws.id == waterSchedule.id);
    waterSchedule.id = -1;
    if (wsIndex > -1) {
      device.waterSchedules[wsIndex] = waterSchedule;
    } else {
      device.waterSchedules.push(waterSchedule);
    }
  }


  validateGatewayInfo(device: Device, sensorUUIDs: Sensor[]): boolean {
    if (device.name == '' || device.description == '' ||
      device.name == undefined || device.description == undefined) {
      this.toastr.error('Please include these required parameters: Name, Description, and Type.');
      return false;
    }

    if (!device.ipAddress || !this.validIPAddress || device.ipAddress==undefined) {
      this.toastr.error('Please include a valid IP address.');
      return false;
    }

    if (device.mode == undefined) {
      this.toastr.error('Please specify dynamic or static sensor assignments.');
      return false;
    }

    if (device.mode == 'static' && sensorUUIDs.length == 0) {
      this.toastr.error('Please include at least one sensor for static mode.');
      return false;
    }

    return true;
  }


  updateGlobalWaterScheduleOwner() {
    this.devices.forEach(device => {
      device.waterSchedules.forEach(dws => {
        if (dws.isSelfOwned) {
          const globalWaterSchedule = this.globalWaterSchedules.find(ws => ws.id == dws.id);
          if (globalWaterSchedule != null) {
            globalWaterSchedule.ownerID = device.id;
            globalWaterSchedule.ownerName = device.name;
          }
        }
      });
    });
  }


  updateGlobalWaterScheduleUsages() {
    this.globalWaterSchedules.forEach(gws => {
      this.updateGlobalWaterScheduleUsage(gws);
    });
  }


  updateGlobalWaterScheduleUsage(globalWaterSchedule: WaterSchedule) {
    globalWaterSchedule.usedByCount = 0;
    globalWaterSchedule.usedByTrigger = [];
    const triggerNames = this.eventConditionsUsingWaterSchedule(globalWaterSchedule);
    globalWaterSchedule.usedByCount += triggerNames.length;
    triggerNames.forEach(t => globalWaterSchedule.usedByTrigger.push(t));
  }


  clearGlobalWaterScheduleParameters() {
    this.globalWaterSchedules.forEach(ws=> {
      ws.isEnabled = false;
      ws.isSelfOwned = false;
      ws.usedByCount = 0;
      ws.usedByTrigger = [];
      ws.ownerID = -1;
      ws.ownerName = '';
    });
  }


  updateGlobalWaterSchedulesUsingDeviceWaterSchedules(device: Device) {
    this.device.waterSchedules.forEach(dws => {
      const globalWaterSchedule = this.globalWaterSchedules.find(ws => ws.id == dws.id);
      if (globalWaterSchedule != null) {
        globalWaterSchedule.isEnabled = dws.isEnabled;
        globalWaterSchedule.isSelfOwned = dws.isSelfOwned;
      }
    });

    this.globalWaterSchedules.sort((x,y) =>(x.isEnabled==y.isEnabled) ? 0 : x.isEnabled? -1 : 1);
  }


  updateGlobalSensorUUIDsUsingDeviceSensorUUIDs(device: Device) {
    this.allSensors.forEach(s=> {
      s.checked = false;
      if (device.sensorUUIDs.find(ds => ds.toLowerCase() == s.uuid.toLowerCase())) {
        s.checked = true;
      }
    });

    this.buildSensorUUIDDisplayList(this.allSensorUUIDsDisplayed);
  }


  mapDeviceNotifications2LocalNotifications(deviceNotifications: DeviceNotification[]) {
    deviceNotifications.forEach(dn => {
      switch (dn.type) {
      case 'NoDeviceResponse':
        this.notifyNoDeviceResponse = dn;
        break;
      case 'NoSensorResponse':
        this.notifyNoSensorResponse = dn;
        break;
      case 'ValueResponse':
        this.notifyValueResponse = dn;
        break;
      default:
        break;
      }
    });
  }


  updateDeviceNotificationRemoveNulls(deviceNotifications: DeviceNotification[]) {
    deviceNotifications.forEach(dn => {
      dn.missedCount = (dn.missedCount == null || dn.missedCount == undefined) ? 0 : dn.missedCount;
      dn.sensorValue = (dn.sensorValue == null || dn.sensorValue == undefined) ? 0 : dn.sensorValue;
      dn.timeSpan = (dn.timeSpan == null || dn.timeSpan == undefined) ? 0 : dn.timeSpan;
    });
  }


  mapLocalNotifications2DeviceNotifications(deviceNotifications: DeviceNotification[]) {
    deviceNotifications.forEach(dn => {
      switch (dn.type) {
      case 'NoDeviceResponse':
        dn = this.notifyNoDeviceResponse;
        break;
      case 'NoSensorResponse':
        dn = this.notifyNoSensorResponse;
        break;
      case 'ValueResponse':
        dn = this.notifyValueResponse;
        break;
      default:
        break;
      }
    });
  }


  // The edit dialog works on a full copy so cancelling can't leave changes behind in the list row (nested sensors, schedules and functions included)
  private cloneDevice(device: Device): Device {
    try {
      return structuredClone(device);
    } catch {
      const copy: Device = JSON.parse(JSON.stringify(device));
      copy.registerDate = device.registerDate;
      copy.aliveTimeStamp = device.aliveTimeStamp;
      return copy;
    }
  }


  editDevice(device: Device, template: TemplateRef<any>) {
    this.hasBluetoothScan=false;
    this.buttonValue='Update';
    this.validIPAddress = false;
    this.changeLogNotes = '';

    if (device.userGroupId == null){
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    } else {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == device.userGroupId);
    }

    this.currentDeviceID = device.id;
    this.device = this.cloneDevice(device);
    this.device.deviceNotifications.forEach(dn => dn.sensorDataType = this.deviceMapping.getReadingTypeFromID(dn.sensorDataType.id, this.sensorReadingTypes));
    this.uploadFileContent = '';
    this.allSensorUUIDsDisplayed = false;

    if (this.device.serialNumber != undefined && this.device.serialNumber != '') {
      this.getDeviceVersionInfo(this.device);
      this.getCloudStorageFileList(this.device.serialNumber);
      this.getGatewayActivityMessages(this.device, 10);
    }

    this.updateGlobalSensorUUIDsUsingDeviceSensorUUIDs(this.device);

    this.preEditObjectAsJSONString = JSON.stringify(this.device);

    this.mapDeviceNotifications2LocalNotifications(this.device.deviceNotifications);

    this.title = 'Edit:  ' + this.device.name;
    this.firstlayermodalref = this.modalService.show(template, this.config);

    this.getSensorUUIDsFromDevice();
    this.clearGlobalWaterScheduleParameters();
    this.updateGlobalWaterSchedulesUsingDeviceWaterSchedules(this.device);
    this.updateGlobalWaterScheduleUsages();
    this.updateGlobalWaterScheduleOwner();
    this.gatewayCommands = this.parseAndFilterGatewayCommands();
  }


  buildSensorUUIDDisplayList(showAll: boolean) {
    this.allSensorUUIDsDisplayed = showAll;

    if (!showAll) {
      this.sensorUUIDsDisplayed = this.allSensors.filter(s => s.checked == true);
    } else {
      this.sensorUUIDsDisplayed = this.allSensors;
    }

    this.updateSensorNameAndType(this.sensorUUIDsDisplayed);
    this.sensorUUIDsDisplayed.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
    this.getLastSensorReadingDatesForSensors(this.sensorUUIDsDisplayed);
  }


  updateSensorNameAndType(sensors: Sensor[]) {
    sensors.forEach(s => {
      if (s.name == undefined || s.name == '') {
        s.name = this.common.extractNameFromUUID(s.uuid, this.btMacAddressPrefixes);
        s.inlineEdited = true;
      }
      if (s.type == undefined || s.type == '') {
        s.type = this.common.extractTypeFromUUID(s.uuid, this.btMacAddressPrefixes);
        s.inlineEdited = true;
      }
    });
  }


  addDevicePopUp(template: TemplateRef<any>) {
    this.device = this.buildNewDevice();
    this.currentDeviceID = this.device.id;

    this.buttonValue = 'Create';
    this.validIPAddress = false;
    this.title = 'Add a new gateway';
    this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    this.device.userName = this.username;
    this.auth.mapUserAccessForDevice(this.device, this.globalSwitch, this.username, this.userGroups);
    this.uploadFileContent = '';
    this.changeLogNotes = '';

    this.allSensorUUIDsDisplayed = false;
    this.updateGlobalSensorUUIDsUsingDeviceSensorUUIDs(this.device);

    this.firstlayermodalref = this.modalService.show(template, this.config);

    this.clearGlobalWaterScheduleParameters();
    this.updateGlobalWaterSchedulesUsingDeviceWaterSchedules(this.device);
    this.updateGlobalWaterScheduleUsages();
    this.updateGlobalWaterScheduleOwner();
    this.mapDeviceNotifications2LocalNotifications(this.device.deviceNotifications);
    this.gatewayCommands = this.parseAndFilterGatewayCommands();
    this.updateGlobalSensorUUIDsUsingDeviceSensorUUIDs(this.device);
  }


  buildNewDevice(): Device {
    const device: Device = {
      id: 0,
      name: 'new device',
      description: '',
      mode: 'Static',
      registerDate: moment.utc().toDate(),
      serialNumber: '',
      macAddress: '',
      ipAddress: '',
      netmask: '',
      networkInterface: '',
      gpsLocation: { id: 0, gpsAlt: 0, gpsLat: 0, gpsLong: 0, locationDescription: ''},
      sensorUUIDs: [],
      waterSchedules: [],
      notificationDestination: '',
      deviceNotifications: this.createNewDeviceNotifications(),
      userName: this.username,
      userGroup: '',
      userGroupId: null,
      aliveTimeStamp: null,
      aliveColor: 'clear',
      connectivity: [],
      ingestStats: [],
      isDisabled: true,
      apiKey: '',
      deviceCameras: [],
      trustInfo: new DeviceRegistration(),
      waterRate: 0,
      // New gateways default to the Basic Gateway preset's functions.
      deviceFunctionIds: this.getPresetFunctionIds('Basic Gateway')
    };

    return device;
  }


  createNewDeviceNotifications(): DeviceNotification[] {
    let deviceNotifications: DeviceNotification[] = [];
    deviceNotifications = [
      {id: 0, type: DeviceNotificationType.NoDeviceResponse, isEnabled: false, missedCount: 0, timeSpan: 0, sensorValue: 0, sensorDataType: { id: 6, type: 'moisture'}},
      {id: 0, type: DeviceNotificationType.NoSensorResponse, isEnabled: false, missedCount: 0, timeSpan: 0, sensorValue: 0, sensorDataType: { id: 6, type: 'moisture'}},
      {id: 0, type: DeviceNotificationType.ValueResponse, isEnabled: false,  missedCount: 0, timeSpan: 0, sensorValue: 0, sensorDataType: { id: 6, type: 'moisture'}}
    ];
    return deviceNotifications;
  }


  newIrrSchedule(): WaterSchedule {
    const newSchedule: WaterSchedule = {
      id: -1,
      name: '',
      isSelfOwned: true,
      timeOff: 0,
      timeOn: 0,
      cycles: 0,
      isEnabled:
      false,
      usedByCount: 0,
      usedByTrigger: [],
      ownerID: this.device.id,
      ownerName: this.device.name,
      ownerChanged: false,
      timerRounds: [{id: 0, on: 1, off: 0, multiplier: 1}]
    };
    return newSchedule;
  }


  addIrrSchedule(irrigationtemplate: TemplateRef<any>){
    this.irrigationButton = 'Create Schedule';
    this.selectedWaterSchedule = this.newIrrSchedule();
    this.secondlayermodalref= this.modalService.show(irrigationtemplate, { animated: false, backdrop: false, ignoreBackdropClick: true } );
  }


  editIrrSchedule(waterSchedule: WaterSchedule, irrigationtemplate: TemplateRef<any>){
    this.selectedWaterScheduleIndex = this.globalWaterSchedules.findIndex( x => x.name === waterSchedule.name);
    this.selectedWaterSchedule = JSON.parse(JSON.stringify(waterSchedule));
    this.selectedWaterSchedule.timerRounds.forEach(tr => {
      tr.id = this.selectedWaterSchedule.timerRounds.findIndex(r => r.id == tr.id);
    });
    this.irrigationButton = 'Update Schedule';
    this.secondlayermodalref = this.modalService.show(irrigationtemplate, { animated: false, backdrop: false, ignoreBackdropClick: true } );
  }


  updateWaterScheduleCycleOnOffValues(updatedWS: WaterSchedule){
    if (updatedWS.name == null || updatedWS.name == '') {
      this.toastr.error('Please provide a name for the schedule');
      return;
    }

    this.secondlayermodalref.hide();

    this.calculateWaterScheduleCycleOnOffValues(updatedWS);

    if (updatedWS.id > -1 && updatedWS.name != this.globalWaterSchedules[this.selectedWaterScheduleIndex].name) {
      this.updateListofWaterScheduleNameChanges(updatedWS);
    }

    if (this.irrigationButton == 'Create Schedule'){
      updatedWS.ownerID = this.device.id;
      updatedWS.isEnabled = true;
      this.globalWaterSchedules.push(updatedWS);
    } else {
      this.globalWaterSchedules[this.selectedWaterScheduleIndex] = updatedWS;
    }

    this.globalWaterSchedules.sort((x,y) => (x.isEnabled==y.isEnabled) ? 0 : x.isEnabled? -1 : 1);
  }


  updateListofWaterScheduleNameChanges(waterSchedule: WaterSchedule) {
    var index = this.waterScheduleNameChanges.findIndex(w => w.id == waterSchedule.id);
    if (index < 0) {
      this.waterScheduleNameChanges.push(waterSchedule);
    }
    else {
      this.waterScheduleNameChanges[index] = waterSchedule;
    }
  }


  calculateWaterScheduleCycleOnOffValues(waterSchedule: WaterSchedule) {
    waterSchedule.cycles = 0;
    waterSchedule.timeOn = 0;
    waterSchedule.timeOff = 0;

    waterSchedule.timerRounds.forEach((x)=>{
      waterSchedule.timeOn += x.on * x.multiplier;
      waterSchedule.timeOff += x.off * x.multiplier;
      waterSchedule.cycles += x.multiplier;
    });
  }


  deleteIrrSchedule(waterSchedule: WaterSchedule, template: TemplateRef<any>){
    const triggernames = this.eventConditionsUsingWaterSchedule(waterSchedule);

    if (triggernames.length != 0) {
      this.scanModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true } );
      return;
    } else {
      this.deletemessage = 'Do you want to delete the ' + waterSchedule.name + ' schedule?';
    }

    this.confirmationService.confirm({
      message: this.deletemessage,
      key: 'cd2',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.removeGlobalWaterSchedule(waterSchedule.name);
      },
      reject: () => {
      }
    });
  }

  removeGlobalWaterSchedule(scheduleName: string) {
    const index = this.globalWaterSchedules.findIndex(x => x.name === scheduleName);
    if (index > -1) {
      this.globalWaterSchedules[index].isEnabled = false;
      this.globalWaterSchedules[index].isSelfOwned = false;
      this.globalWaterSchedules.splice(index, 1);
    }
  }


  eventConditionsUsingWaterSchedule(waterSchedule: WaterSchedule): string[] {
    const eventNames: string[] = [];
    if (waterSchedule == null || this.events == null) {
      return eventNames;
    }
    this.events.forEach(event => {
      if (event.eventActions != null) {
        event.eventActions.forEach(a => {
          if (a.scheduleID > -1 && a.scheduleID == waterSchedule.id) {
            eventNames.push(event.name);
          }
          else if (a.scheduleName != undefined && a.scheduleName.toLowerCase() == waterSchedule.name.toLowerCase()) {
            eventNames.push(event.name);
          }
        });
      }
    });
    return eventNames;
  }


  getOwnerName(device: Device): string{
    if(device.userGroupId > 0){
      return device.userGroup;
    }else{
      return device.userName;
    }
  }


  getDeviceFunctions(): void {
    this.deviceService.getDeviceFunctions().subscribe(
      results => {
        if (results != null) {
          this.deviceFunctions = results;
        }
      },
      err => {
        this.toastr.error('Error occurred while retrieving device functions');
      });
  }


  isDeviceFunctionChecked(deviceFunctionId: number): boolean {
    return this.device?.deviceFunctionIds?.includes(deviceFunctionId) ?? false;
  }


  toggleDeviceFunction(deviceFunctionId: number): void {
    if (this.device.deviceFunctionIds == null) {
      this.device.deviceFunctionIds = [];
    }

    const index = this.device.deviceFunctionIds.indexOf(deviceFunctionId);
    if (index === -1) {
      this.device.deviceFunctionIds.push(deviceFunctionId);
    } else {
      this.device.deviceFunctionIds.splice(index, 1);
    }
  }


  toggleAllDeviceFunctions(): void {
    const allChecked = this.deviceFunctions.length > 0 && this.deviceFunctions.every(df => this.isDeviceFunctionChecked(df.id));

    if (allChecked) {
      this.device.deviceFunctionIds = [];
    } else {
      this.device.deviceFunctionIds = this.deviceFunctions.map(df => df.id);
    }
  }


  // Resolve a preset's function NAMES to the DeviceFunction ids present in this
  // environment (unknown names are simply skipped).
  getPresetFunctionIds(presetLabel: string): number[] {
    const preset = this.gatewayFunctionPresets.find(p => p.label === presetLabel);
    if (preset == undefined) {
      return [];
    }
    return this.deviceFunctions
      .filter(df => preset.functionNames.includes(df.name))
      .map(df => df.id);
  }


  // The preset whose function set exactly matches the current selection, or 'Custom'
  // when it matches none. Drives the radio row and updates live as the admin toggles
  // individual checkboxes (breaking a preset flips the radio to Custom).
  get selectedGatewayPreset(): string {
    const selected = this.device?.deviceFunctionIds ?? [];
    const match = this.gatewayFunctionPresets.find(preset => {
      const presetIds = this.getPresetFunctionIds(preset.label);
      return presetIds.length === selected.length
        && presetIds.every(id => selected.includes(id));
    });
    return match != undefined ? match.label : this.customGatewayPresetLabel;
  }


  // Apply a preset from the radio row. 'Custom' leaves the current selection as-is
  // (the admin then customizes via the checkboxes); a named preset replaces the
  // selection with exactly that preset's functions.
  applyGatewayPreset(presetLabel: string): void {
    if (presetLabel === this.customGatewayPresetLabel) {
      return;
    }
    this.device.deviceFunctionIds = this.getPresetFunctionIds(presetLabel);
  }


  openScanModal(template: TemplateRef<any>): void {
    this.scanModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true } );
    this.scannedSensor = '';
  }


  public scanComplete(event: string): void {
    this.visitedScan = false;

    if (this.scannedSensor == '') {
      const splitEvent = this.createUUID(event);

      this.sensorUUIDsDisplayed.forEach(sensor => {
        if (sensor['uuid'].toLowerCase() === splitEvent.toLowerCase() && sensor['checked'] == true) {
          this.toastr.error('This sensor is already selected');
          this.visitedScan = true;
          return;
        }
      });

      if (!this.visitedScan) {
        this.toastr.success('Scanned ' + event);
        this.scannedSensor = event;
        this.visitedScan = false;
      }
    } else {
      this.toastr.warning('Please choose to add or ignore current sensor');
    }
  }


  public camerasFound(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;
    if (this.availableDevices.length > 0) {
      this.onDeviceSelectChange(this.availableDevices[this.availableDevices.length-1].deviceId);
    }
  }


  onDeviceSelectChange(selectedValue: string) {
    this.selectedDevice = this.availableDevices.find(x => x.deviceId == selectedValue);
  }


  ignoreSensor(): void {
    if (this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
    } else {
      this.toastr.warning('Ignored ' + this.scannedSensor);
      this.scannedSensor = '';
    }
  }


  public createUUID(uuid): string {
    uuid = uuid.split(':').join('');
    const formattedUUID = [];
    const maxLength = 36;
    let uuidLengthTracker=uuid.length-1;
    for(let i = 0; i <= maxLength-1; i++) {
      if(i == 12 || i == 17 || i == 22 || i == 27) {
        formattedUUID.unshift('-');
      } else if(uuidLengthTracker>=0) {
        formattedUUID.unshift(uuid.charAt(uuidLengthTracker));
        uuidLengthTracker--;
      } else{
        formattedUUID.unshift('0');
      }
    }
    return formattedUUID.join('');
  }


  public addSensor(): void {
    if (this.scannedSensor == undefined || this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }

    this.scannedSensor = this.createUUID(this.scannedSensor);

    this.allSensors.forEach(sensor => {
      if (sensor['uuid'].toLowerCase() === this.scannedSensor.toLowerCase()) {
        const sensorIndex = this.allSensors.indexOf(sensor);
        sensor['checked'] = true;
        this.sensorToAdd = sensor;
        this.scannedSensor = '';
        this.allSensors.splice(sensorIndex, 1);
        this.allSensors.unshift(this.sensorToAdd);
        this.toastr.success('Sensor found in database and adding to list');
        this.buildSensorUUIDDisplayList(this.allSensorUUIDsDisplayed);
        return;
      }
    });

    if (!(this.scannedSensor == '')) {
      this.sensorToAdd = {
        id: 0,
        uuid: this.scannedSensor.toLowerCase(),
        sensorReadingTypes: undefined,
        sensorReadingTypeNames: '',
        checked: true,
        modifiedDate: new Date(),
        userName: this.username,
        userGroupId: undefined,
        virtualSensor: undefined,
        lastReading: this.common.createNewLastReading(0),
        sensorCalibrationHistory: null,
      };
      this.allSensors.unshift(this.sensorToAdd);
      this.toastr.success('Successfully added new sensor');
      this.scannedSensor = '';
      this.buildSensorUUIDDisplayList(this.allSensorUUIDsDisplayed);
    }
  }


  duplicateNamecheck(name: string): void{
    if (name.match(/ /g) || name.match(/:/g)) {
      this.toastr.error('Gateway name cannot use spaces or colons');
      this.duplicateName = true;
      return;
    }
    for (const device of this.devices) {
      if(device.name == name && device.id != this.device.id){
        this.toastr.error('Gateway name is already registered');
        this.duplicateName = true;
        break;
      } else{
        this.duplicateName = false;
      }
    }
  }


  duplicateSerialcheck(serial: string): boolean {
    this.duplicateSerial = false;

    if (serial == undefined || serial == '' || serial.length < 10) {
      this.toastr.error('Gateway serial# field must contain a value longer than 10 characters');
      this.duplicateSerial = true;
      return true;
    }

    if (serial.match(/ /g) || serial.match(/:/g) || serial.match(/-/g) || serial.match(/_/g)) {
      this.toastr.error('Gateway serial# cannot use spaces, colons, dashes, or underscores');
      this.duplicateSerial = true;
      return true;
    }

    for (const device of this.devices) {
      if (device.serialNumber == serial && device.id != this.device.id){
        this.toastr.error('Gateway serial# is already being used');
        this.duplicateSerial = true;
        return true;
      }
    }

    return false;
  }


  duplicateWSname(name: string){
    this.duplicateWaterSchedulename = false;
    if (name.match(/ /g)){
      this.toastr.error('Schedule name cannot use spaces');
      this.duplicateWaterSchedulename = true;
    }
    if(this.globalWaterSchedules){
      for(let i = 0; i < this.globalWaterSchedules.length; i++){
        if(this.globalWaterSchedules[i].name == name && this.selectedWaterScheduleIndex != i){
          this.toastr.error('Irrigation schedule name already exists');
          this.duplicateWaterSchedulename = true;
          break;
        }
      }
    }
  }


  mapDevice2GatewayInfo(device: Device): GatewayInfo {
    const gatewayInfo: GatewayInfo = {
      id: device.id,
      name: device.name,
      description: device.description,
      //type: this.deviceMapping.getDeviceTypeForDeviceTypeString(device.type),
      mode: device.mode,
      registerDate: device.registerDate,
      serialNumber: device.serialNumber,
      macAddress: device.macAddress,
      ipAddress: device.ipAddress,
      netmask: device.netmask,
      networkInterface: device.networkInterface,
      gpsLocation: device.gpsLocation,
      sensorUUIDs: device.sensorUUIDs,
      mountAngle: device.mountAngle
    };

    return gatewayInfo;
  }


  getHWConfigurationFromGateway() {
    this.loadingHardwareInfo = true;
    this.gatewayInfo = this.deviceMapping.mapDevice2DeviceInfo(this.buildNewDevice());
    this.gatewayInfo.networkInterface = '';
    const task = this.buildNewTask(this.currentDeviceID, '/home/pi/kigs/scripts/tasks/getDeviceInfoJSON.sh', '');
    this.deviceService.postTask(task, '', 3).subscribe(
      results => {
        if (results != null && results != '') {
          this.gatewayInfo = JSON.parse(results);
        }
        else {
          this.toastr.warning('No information found for device.');
        }
        this.loadingHardwareInfo = false;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
        this.loadingHardwareInfo = false;
      });
  }


  getSensorUUIDsFromDevice() {
    this.retrievingGatewaySensorInfo = true;
    this.gatewaySensorUUIDs = [];
    if (this.device.sensorUUIDs.length > 0) {
      const task = this.buildNewTask(this.currentDeviceID, '/home/pi/kigs/scripts/tasks/getSensorsJSON.sh', '');
      this.deviceService.postTask(task, '', 3).subscribe(
        results => {
          if (results != null && results != '') {
            results = JSON.parse(results);
            results.forEach(s => {
              this.gatewaySensorUUIDs.push( { id: 0, uuid: s.uuid, sensorReadingTypes: null, checked: true, modifiedDate: new Date(), sensorReadingTypeNames: '', userName: this.username, userGroupId: null, virtualSensor: undefined, sensorCalibrationHistory: [], } );
            });
            if ((this.gatewaySensorUUIDs.length - 1) > this.device.sensorUUIDs.length) {
              this.toastr.warning('There are more sensors associated with the gateway than shown under the Sensors tab. Update recommended.');
            }
          } else{
            this.toastr.warning('Device sensor list not available');
          }

          this.retrievingGatewaySensorInfo = false;
        },
        err => {
          this.toastr.error('Error occurred while retrieving device sensors.');
          this.retrievingGatewaySensorInfo = false;
          return;
        });
    }
  }


  buildNewTask(deviceID: number, action: string, payload: string): Task {
    const task: Task = {
      taskID: -1,
      deviceID,
      clientID: this.common.generateUUID(),
      priority: 1,
      type: 1,
      action,
      payload,
      expireTimeSec: 87,
      taskWaitIntervalSec: 2,
      waitForResult: true
    };

    return task;
  }


  getDeviceSensorSyncColor(checkedUUID: string): string {
    const uuidMatch = this.gatewaySensorUUIDs.find(s => s.uuid.toLowerCase() == checkedUUID.toLowerCase());

    if (uuidMatch == null) {
      return 'black';  // "black";
    } else {
      return '#5c8f3a';  // Green
    }
  }


  getDeviceSensorSyncStatus(checkedUUID: string): string {
    const uuidMatch = this.gatewaySensorUUIDs.find(s => s.uuid.toLowerCase() == checkedUUID.toLowerCase());

    if (uuidMatch == null) {
      return '?';
    } else {
      return 'yes';
    }
  }


  getDeviceAliveColor(timeStamp: Date): string {

    if (timeStamp == null) {
      return 'lightgray';
    }

    const duration = moment.duration(moment().diff(this.getFormattedDate(timeStamp)));
    const diffMinutes = Math.abs(duration.asMinutes());

    if (diffMinutes <= 2) {
      return '#a9d18e';   //"#00C851";   // green
    } else if (diffMinutes <= 5) {
      return '#f3f428';  // yellow
    } else if (diffMinutes <= 60) {
      return '#F7680C';  // orange
    } else {
      return '#FF0000';  // red
    }
  }


  getDeviceAliveStatus(timeStamp: Date): string {
    if (timeStamp == null) {
      return 'no record';
    } else {
      return this.getFormattedDate(timeStamp);
    }
  }


  getDeviceConnectivityColor(uptimePercent: number): string {

    if (uptimePercent >= 98) {
      return '#a9d18e';               // green
    } else if (uptimePercent >= 95) {
      return '#f3f428';               // yellow
    } else if (uptimePercent >= 80) {
      return '#F7680C';               // orange
    } else {
      return '#FF0000';               // red
    }
  }


  getConnectivityToolTipInfo(device: Device, connectId: number): string {
    return device.connectivity[connectId].timePeriod.toString() + '-hr : ' + device.connectivity[connectId].value.toString() + '%';
  }


  getIngestStatToolTipInfo(device: Device, index: number): string {
    return device.ingestStats[index].timePeriod.toString() + '-hr';
  }


  displayHardwareInfoFromDevice(template: TemplateRef<any>) {
    this.getHWConfigurationFromGateway();
    this.hwModalRef = this.hwModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false } );
  }


  applyHardwareInfoFromGateway() {
    this.device.ipAddress = this.gatewayInfo.ipAddress;
    this.device.netmask = this.gatewayInfo.networkInterface;
    this.device.networkInterface = this.gatewayInfo.networkInterface;
    this.device.serialNumber = this.gatewayInfo.serialNumber;
    this.device.macAddress = this.gatewayInfo.macAddress;
    this.device.gpsLocation.gpsAlt = this.gatewayInfo.gpsLocation.gpsAlt;
    this.device.gpsLocation.gpsLat = this.gatewayInfo.gpsLocation.gpsLat;
    this.device.gpsLocation.gpsLong = this.gatewayInfo.gpsLocation.gpsLong;
    this.device.gpsLocation.locationDescription = this.gatewayInfo.gpsLocation.locationDescription;
    this.device.gpsLocation.id = 0;
    this.hwModalRef.hide();
  }


  isInvalidDate = (m: moment.Moment) => this.invalidDates.some(d => d.isSame(m, 'day'));


  datesUpdated(): void {
    if (this.selectedDateRange != undefined) {
      if (this.selectedDateRange.startDate != null && this.selectedDateRange.endDate != null) {
        this.startDate = this.selectedDateRange.startDate.toDate();
        this.endDate = this.selectedDateRange.endDate.toDate();
        if (this.logMode == 'irrigationLogs') {
          this.deviceLogs = this.irrigationLogs.filter((x) => x.date >= this.startDate && x.date <= this.endDate);
        } else {
          this.deviceLogs = this.systemLogs.filter((x) => x.date >= this.startDate && x.date <= this.endDate);
        }
      } else {
        this.startDate = null;
        this.endDate = null;
      }
    }
  }


  checkLogMode(){
    if(this.logMode == 'irrigationLogs'){
      this.deviceLogs = this.irrigationLogs;
    } else {
      this.deviceLogs = this.systemLogs;
    }
    this.datesUpdated();
  }


  showWaterScheduleUsage(waterSchedule: WaterSchedule, template: TemplateRef<any>) {
    this.currentWaterScheduleUsage = waterSchedule.usedByTrigger;
    if (this.currentWaterScheduleUsage.length > 0) {
      this.wsModalRef = this.logModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false } );
    }
  }


  showWaterScheduleOwners(waterSchedule: WaterSchedule, template: TemplateRef<any>) {
    this.currentWaterScheduleID = waterSchedule.id;
    this.currentDevices = [];
    this.devices.forEach(d => {
      if (d.id != this.currentDeviceID) {
        this.currentDevices.push(d.name);
      }
    });
    this.wsModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true } );
  }


  assignOwnerToCurrentWaterSchedule(deviceName: string) {
    const device = this.devices.find(d => d.name.toLowerCase() === deviceName.toLowerCase());
    const waterSchedule = this.globalWaterSchedules.find(ws => ws.id == this.currentWaterScheduleID);

    if (waterSchedule != undefined && device != undefined) {
      waterSchedule.ownerID = device.id;
      if (device.id != this.device.id) {
        waterSchedule.ownerChanged = true;
      } else {
        waterSchedule.ownerChanged = false;
      }
    }
    this.wsModalRef.hide();
  }


  launchIrrigationLogs(template: TemplateRef<any>) {
    this.selectedDateRange = '';
    this.logMode = 'irrigationLogs';
    this.logModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true } );
    this.getIrrigationLogs(this.device.id);
  }


  getIrrigationLogs(deviceID: number) {
    this.irrigationLogs = [];
    const task = this.buildNewTask(deviceID, '/home/pi/kigs/scripts/tasks/getIrrigationLogs.sh', '');
    this.deviceService.postTask(task, 'getting irrigation logs from gateway', 2).subscribe(
      results => {
        if (results != null) {
          const lines: string[] = results.split('\n');
          const receivedDeviceLog: DeviceLog[] = [];
          lines.forEach( x => {
            const items: string[] = x.split(' - ');
            receivedDeviceLog.push({ date: new Date(items[0]), msg: items[1] });
          });

          this.irrigationLogs = receivedDeviceLog.reverse();
        } else {
          this.toastr.warning('No irrigation logs found.');
        }
        this.datesUpdated();
        this.awaitIrrigationLogs = true;
      });
  }


  public exportCsv(value: { data: any; field: string }) {
    if (value.field === 'date') {
      return new DatePipe('en-US').transform(value.data, 'MMM d, y, h:mm:ss a');
    } else {
      return String(value.data);
    }
  }


  executeLiveCommand(template: TemplateRef<any>, command: string, payload: string, waitMessage: string) {
    if (this.gatewayLiveCommand == '' && command == '') {
      return;
    }

    if (command == '') {
      command = this.gatewayLiveCommand;
      payload = ''; //this.gatewayLivePayload;
    }

    if (payload != '') {
      payload = window.btoa(payload);
    }

    const task = this.buildNewTask(this.device.id, command, payload);

    this.deviceService.postTask(task, waitMessage, 4).subscribe(
      results => {
        this.toastr.success('Gateway task sent');
        if (results != null) {
          this.gatewayLiveCommandResults = results;
          this.uploadFileContent = results;

          if (template != null) {
            this.logModalRef = this.modalService.show(template);
          }
        } else {
          this.toastr.warning('No response from device');
        }
      });
  }


  remoteContentViewEditLive(template: TemplateRef<any>, pathAndFileToEdit: string) {
    if (pathAndFileToEdit == "") {
      return;
    }

    this.uploadFileContent = '';
    this.remoteFileContentLoadCommands = [];
    this.remoteFileContentSaveCommands = [];
    this.remoteFileContentRestoreCommands = [];

    var pathFileSplit = pathAndFileToEdit.split('/');
    var filename = pathFileSplit[pathFileSplit.length - 1];

    this.remoteContentReference = `Edit ${pathAndFileToEdit}`;
    this.remoteFileContentLoadCommands.push( `/bin/cat ${pathAndFileToEdit}` );
    this.remoteFileContentSaveCommands.push( `backupFileContent.sh ${pathAndFileToEdit}` );
    this.remoteFileContentSaveCommands.push( `saveFileContent.sh ${pathAndFileToEdit} <content>` );
    this.remoteFileContentRestoreCommands.push( `/bin/cp /home/pi/kigs/originals/${filename} ${pathAndFileToEdit}` );

    this.loadFileContentFromDevice(template);
  }


  loadFileContentFromDevice(template: TemplateRef<any>) {
    this.remoteFileContentLoadCommands.forEach(command => {
      this.executeLiveCommand(template, command, '', 'Executing command ...');
    });
  }


  saveContentToDevice() {
    this.remoteFileContentSaveCommands.forEach(command => {
      if (command.includes('<content>')) {
        command = command.replace(/<content>/g, '');
        this.executeLiveCommand(null, command, this.uploadFileContent, 'Executing command ...');
      } else {
        this.executeLiveCommand(null, command, '', 'Executing command ...');
      }
    });

    this.loadFileContentFromDevice(null);
  }


  sendFileToDevice(fileContent: string, pathAndFileToEdit: string, isExecutable: boolean) {
    if (pathAndFileToEdit == "") {
      return;
    }

    this.uploadFileContent = fileContent;
    this.remoteFileContentSaveCommands = [];

    this.remoteFileContentSaveCommands.push( `saveFileContent.sh ${pathAndFileToEdit}` );

    if (isExecutable) {
      this.remoteFileContentSaveCommands.push( `/usr/bin/chmod 777 ${pathAndFileToEdit}`);  // newer pi os versions
      this.remoteFileContentSaveCommands.push( `/bin/chmod 777 ${pathAndFileToEdit}`);
    }

    this.remoteFileContentSaveCommands.forEach(command => {
        this.executeLiveCommand(null, command, this.uploadFileContent, '');
    });
  }


  restoreContentToDevice() {
    this.remoteFileContentRestoreCommands.forEach(command => {
      this.executeLiveCommand(null, command, '', 'Executing command ...');
    });

    this.loadFileContentFromDevice(null);
  }


  getHiddenSerialNumber(serialNumber: string): string {
    if (serialNumber.length < 5) {
      return serialNumber;
    } else {
      return '...' + serialNumber.slice(serialNumber.length - 4);
    }
  }


  copySerialNumber(serialNumber: string, event?: MouseEvent): void {
    if (event != undefined) event.stopPropagation();
    if (serialNumber == undefined || serialNumber == '') return;

    navigator.clipboard.writeText(serialNumber).then(
      () => this.toastr.success('Serial number copied to clipboard'),
      () => this.toastr.error('Unable to copy serial number to clipboard')
    );
  }


  searchSensorsTextChanged() {
    const searchLimit = 200;
    let checkedCount = 0;

    if (this.sensorSearch == '' || this.sensorSearch == '*') {
      this.sensorUUIDsDisplayed = this.sensorUUIDsDisplayed.filter(s => s.checked == true);
      checkedCount = this.sensorUUIDsDisplayed.length;
    } else {
      const searchResults = this.allSensors.filter(s => (s.uuid != undefined ? s.uuid.toLowerCase().includes(this.sensorSearch.toLowerCase()) : false) ||
                                                      (s.name != undefined ? s.name.toLowerCase().includes(this.sensorSearch.toLowerCase()) : false) ||
                                                      (s.type != undefined ? s.type.toLowerCase().includes(this.sensorSearch.toLowerCase()) : false) ||
                                                      s.checked == true);
      const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

      searchResults.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
      this.sensorUUIDsDisplayed = searchResults.slice(0, displayCount);
      this.sensorUUIDsDisplayed.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? 1 : -1);
    }

    this.getLastSensorReadingDatesForSensors(this.sensorUUIDsDisplayed);
  }


  getAllDeviceVersionInfo() {
    this.devices.forEach(device => {
      this.getDeviceVersionInfo(device);
    });
  }


  getDeviceVersionInfo(device: Device) {
    device.version = 'checking';
    //const task = this.buildNewTask(device.id, '/bin/cat /home/pi/kigs/version.txt', '');
    const task = this.buildNewTask(device.id, '/home/pi/kigs/scripts/tasks/getVersion', '');
    this.deviceService.postTask(task, '', 4).subscribe(
      results => {
        if (results != undefined && results != null && results != '') {

          try {
            var jsonResults = JSON.parse(results);

            device.version = jsonResults.version;
            device.versionTooltip = '';
            Object.keys(jsonResults).forEach(key => {
              if (key.toLowerCase() !== 'version') {
                device.versionTooltip += `${key}: ${jsonResults[key]}\n`;
              }
            });
          } catch (e) {
            device.version = results;
            device.versionTooltip = '';
          }
          
        } else {
          device.version = '*';
        }
      },
      err => {
      });
  }


  bluetoothScanReady(device: Device) {
    if (device.version == undefined || device.version.toLowerCase() == '*' || device.version.toLowerCase() == 'checking') {
      return false;
    }
    return true;
  }


  isDeviceVersionEqualOrGreaterTo(device: Device, version: string): boolean {
    var deviceVersion = device.version.split('.').map(x => Number(x) || 0);
    while (deviceVersion.length < 3) { deviceVersion.push(0) }

    var compareVersion = version.split('.').map(x => Number(x) || 0);
    while (compareVersion.length < 3) { compareVersion.push(0) } 

    if (deviceVersion[0] > compareVersion[0]) return true;
    if (deviceVersion[0] < compareVersion[0]) return false;

    if (deviceVersion[1] > compareVersion[1]) return true;
    if (deviceVersion[1] < compareVersion[1]) return false;

    if (deviceVersion[2] > compareVersion[2]) return true;
    if (deviceVersion[2] < compareVersion[2]) return false;

    return true;
  }


  getDeviceIPInfo() {
    this.devices.forEach(device => {
      const task = this.buildNewTask(device.id, '/sbin/ifconfig', '');
      this.deviceService.postTask(task, '', 3).subscribe(
        results => {
          console.log(results);
        },
        err => {
        });
    });
  }


  createMessageData(msgActionType: MessageActionType, device: Device, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.Devices,
      actionType: msgActionType,
      appComponentItem: device.name,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: device.userGroupId
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  gatewayDeviceChanges(device: Device): boolean {

    if (this.preEditObjectAsJSONString == '') return true;

    const original: Device = JSON.parse(this.preEditObjectAsJSONString);

    if ( this.common.compareProperty('Name', original.name, device.name) != "") return true;
    if ( this.common.compareProperty('SerialNumber', original.serialNumber, device.serialNumber) ) return true;
    if ( this.common.compareProperty('MountAngle', original.mountAngle.toString(), device.mountAngle.toString()) ) return true;
    if ( this.common.compareProperty('SensorMode', original.mode, device.mode) ) return true;
    if ( this.common.compareProperty('GPS-Lat', original.gpsLocation.gpsLat.toString(), device.gpsLocation.gpsLat.toString()) ) return true;
    if ( this.common.compareProperty('GPS-Long', original.gpsLocation.gpsLong.toString(), device.gpsLocation.gpsLong.toString()) ) return true;
    if ( this.common.compareProperty('GPS-Alt', original.gpsLocation.gpsAlt.toString(), device.gpsLocation.gpsAlt.toString()) ) return true;
    if ( this.checkSensorChanges(original.sensorUUIDs, device.sensorUUIDs) ) return true;

    if ( !this.retrievingGatewaySensorInfo && this.sensorUUIDsDisplayed.filter(s => s.checked == true).length > 0) {
      var flag = false;
      this.sensorUUIDsDisplayed.filter(s => s.checked == true).forEach(s => {
        if (this.getDeviceSensorSyncStatus(s.uuid) == '?') {
          flag = true;
        }
      });
      return flag;
    }

    return false;
  }


  getEditChanges(device: Device): string {
    let results = '';

    if (this.preEditObjectAsJSONString != '') {
      const original: Device = JSON.parse(this.preEditObjectAsJSONString);

      results += this.common.compareProperty('Name', original.name, device.name);
      results += this.common.compareProperty('Description', original.description, device.description);
      results += this.common.compareProperty('SensorMode', original.mode, device.mode);
      results += this.common.compareProperty('SerialNumber', original.serialNumber, device.serialNumber);
      results += this.common.compareProperty('UserGroupID', this.common.prepareProperty4String(original.userGroupId), this.common.prepareProperty4String(device.userGroupId));
      results += this.common.compareProperty('Email', original.notificationDestination, device.notificationDestination);
      results += this.common.compareProperty('MountAngle', original.mountAngle.toString(), device.mountAngle.toString());
      results += this.common.compareProperty('WaterRate', original.waterRate.toString(), device.waterRate.toString());
      //results += this.common.compareProperty('SensorCount', original.sensorUUIDs.length.toString(), device.sensorUUIDs.length.toString());

      results += this.checkWaterScheduleChanges(original.waterSchedules, device.waterSchedules);
      results += this.checkDeviceCameraChanges(original.deviceCameras, device.deviceCameras);
      results += this.checkSensorChanges(original.sensorUUIDs, device.sensorUUIDs);

      results += this.common.compareProperty('GPS-Lat', original.gpsLocation.gpsLat.toString(), device.gpsLocation.gpsLat.toString());
      results += this.common.compareProperty('GPS-Long', original.gpsLocation.gpsLong.toString(), device.gpsLocation.gpsLong.toString());
      results += this.common.compareProperty('GPS-Alt', original.gpsLocation.gpsAlt.toString(), device.gpsLocation.gpsAlt.toString());

      results += this.common.compareProperty('Notify-Device-Enable', original.deviceNotifications[0].isEnabled.toString(), device.deviceNotifications[0].isEnabled.toString());
      results += this.common.compareProperty('Notify-Device-MissedCount', original.deviceNotifications[0].missedCount .toString(), device.deviceNotifications[0].missedCount.toString());
      results += this.common.compareProperty('Notify-Device-span', original.deviceNotifications[0].timeSpan.toString(), device.deviceNotifications[0].timeSpan.toString());
      results += this.common.compareProperty('Notify-Sensor-Enable', original.deviceNotifications[1].isEnabled.toString(), device.deviceNotifications[1].isEnabled.toString());
      results += this.common.compareProperty('Notify-Sensor-MissedCount', original.deviceNotifications[1].missedCount .toString(), device.deviceNotifications[1].missedCount.toString());
      results += this.common.compareProperty('Notify-Sensor-span', original.deviceNotifications[1].timeSpan.toString(), device.deviceNotifications[1].timeSpan.toString());

      results += this.common.compareProperty('Monitored', this.common.prepareProperty4String(original.isDisabled), this.common.prepareProperty4String(device.isDisabled));
    }

    return results;
  }


  checkWaterScheduleChanges(origSchedules: WaterSchedule[], newSchedules: WaterSchedule[]): string {
    var response = "";

    origSchedules.forEach(o => {
      var index = newSchedules.findIndex(n => n.id == o.id);
      if (index < 0) {
        response += "Schedule removed (" + o.name + "),  ";
      }
    });

    newSchedules.forEach(n => {
      if (n.id == -1) {
        response += "Schedule added (" + n.name + "),  ";
      }
    });

    origSchedules.forEach(o => {
      var n = newSchedules.find(n => n.id == o.id);
      if (n != undefined) {
        if (o.name != n.name) {
          response += "Schedule name (" + o.name + " -> " + n.name + "),  ";
        }

        var origSchedJSON = JSON.stringify(o.timerRounds);
        var newSchedJSON = JSON.stringify(n.timerRounds);

        if (origSchedJSON != newSchedJSON) {
          response += n.name + "-timing (" + origSchedJSON + " -> " + newSchedJSON + "),  ";
        }
      }
    });

    return response;
  }


  checkDeviceCameraChanges(origCameras: DeviceCamera[], newCameras: DeviceCamera[]): string {
    var response = "";

    origCameras.forEach(o => {
      var index = newCameras.findIndex(n => n.id == o.id);
      if (index < 0) {
        response += "Camera removed (" + o.name + "),  ";
      }
    });

    newCameras.forEach(n => {
      if (n.id < 1) {
        response += "Camera added (" + n.name + "),  ";
      }
    });

    origCameras.forEach(o => {
      var n = newCameras.find(n => n.id == o.id);
      if (n != undefined) {
        if (o.name != n.name) {
          response += "Camera name (" + o.name + " -> " + n.name + "),  ";
        }
        if (o.type != n.type) {
          response += "For camera:" + n.name + " - Type (" + o.type + " -> " + n.type + "),  ";
        }
        if (o.model != n.model) {
          response += "For camera:" + n.name + " - Model (" + o.model + " -> " + n.model + "),  ";
        }
        if (o.port != n.port) {
          response += "For camera:" + n.name + " - Port (" + o.port + " -> " + n.port + "),  ";
        }
        if (o.login != n.login) {
          response += "For camera:" + n.name + " - Login (" + o.login + " -> " + n.login + "),  ";
        }
      }
    });

    return response;
  }


  checkSensorChanges(origSensors: string[], newSensors: string[]): string {
    var response = "";

    origSensors.forEach(origUUID => {
      var index = newSensors.findIndex(newUUID => newUUID == origUUID);
      if (index < 0) {
        response += "Sensor removed (" + origUUID + "),  ";
      }

      if (this.getDeviceSensorSyncStatus(origUUID) == 'unknown') {
        response += "Sensor needed syncing (" + origUUID + "),  ";
      }
    });

    newSensors.forEach(newUUID => {
      var index = origSensors.findIndex(origUUID => origUUID == newUUID);
      if (index < 0) {
        response += "Sensor added (" + newUUID + "),  ";
      }
    });

    return response;
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';
    
    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }


  showSensorDataPreviewForDevice(device: Device): void {
    var sensor = this.allSensors.find(x => x.uuid.toLowerCase() == device.serialNumber.toLowerCase());
    if (sensor == undefined) {
      this.toastr.error("Unable to locate sensor UUID associated with this gateway");
      return;
    }
    this.showSensorDataPreviewForSensor(sensor);
  }


  showSensorDataPreviewForSensor(sensor: Sensor): void {
    this.loadSavedSettings();
    
    const params: SensorDataModalParams = {
      sensor: sensor,
      selectedTimeZone: this.selectedTimeZone,
      selectedTimeZoneOffset: this.selectedTimeZoneOffset,
      selectedDateRange: { startDate: moment().startOf('day').add(-7, 'days'), endDate: moment().endOf('day') },
      selectedDefaultReadingType: 'connectivity'
    };

    this.modalService.show(SensorDataModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }

  
  loadSavedSettings() {
    [this.selectedTimeZone, this.selectedTimeZoneOffset] = this.common.setTimeZoneSelection(localStorage.getItem('TimeZoneSelected'));
  }


  onDeviceEnable(value: any) {
    this.device.isDisabled = !value.checked;
    this.device.isDisabledColor = this.getEnabledColor(this.device.isDisabled);
  }


  private getEnabledColor(isDisabled: boolean): string {
    if (isDisabled == false) {
      return '#a9d18e';  //'#33FF33';
    } else {
      return 'white';
    }
  }


  addCamera() {
    const cameraConfig: DeviceCamera = {
      id: 0,
      deviceId: this.device.id,
      name: "",
      type: "",
      model: "",
      port: "",
      login: "kig-viewer:@ccess2PTZ",     // In the future needs to come from settings table in database now or when saved to db
      presets: [],
      power: "power"
    };
    this.device.deviceCameras.push(cameraConfig);
  }


  delCamera(index: number) {
    this.device.deviceCameras.splice(index, 1);
    this.device.deviceCameras = [...this.device.deviceCameras];
  }


  getDeviceTrustMessageForTooltip(device: Device): string {
    if (device.trustInfo == undefined) {
      return '';
    }

    if (device.trustInfo.isRegistered == false) {
      return "Virtual Device?  Click 'R' to register as a virtual device or use gateway hardware to self-register";
    }
    else if (device.trustInfo.isTrusted && device.trustInfo.isVirtual) {
      return `Virtual device registered and trusted. Expires in ${device.trustInfo.expireDays} days.  Click thumb to untrust`;
    }
    else if (device.trustInfo.isTrusted && !device.trustInfo.isVirtual) {
      return `Device registered and trusted. Expires in ${device.trustInfo.expireDays} days.  Click thumb to untrust`;
    }
    else if (!device.trustInfo.isTrusted && !device.trustInfo.isVirtual) {
      return `Device registered but not trusted. Expires in ${device.trustInfo.expireDays} days.  Click thumb to trust`;
    }
    else if (!device.trustInfo.isTrusted && device.trustInfo.isVirtual) {
      return `Virtual device registered but not trusted. Expires in ${device.trustInfo.expireDays} days.  Click thumb to trust or 'R' to remove registration`;
    }
  }


  getRegistrationExpireMessage(device: Device): string {
    if (device.trustInfo != undefined) {
      return `Expires in ${device.trustInfo.expireDays} days`
    }
    else {
      return "";
    }
  }


  registerDevice(device: Device, template: TemplateRef<any>) {
    if (device.trustInfo.isRegistered) {
      return;
    }

    this.registrationConfirmMode = 'new';
    this.registrationConfirmDevice = device;
    this.registrationConfirmResultsTemplate = template;
    this.registrationTokenType = 'Es256';
    this.registrationConfirmHeader = 'Gateway security registration confirmation';
    this.registrationConfirmMessage = "This device does not have a security registration.  Clicking on 'Continue' will complete the security registration and generate a new token.  Proceed if this is a virtual or non-KIG gateway device or if treating your physical device as a virtual device. Note, the token that appears on the next screen will not be saved.  You must copy-and-save.";

    this.registrationConfirmModalRef = this.modalService.show(this.registrationConfirmTemplate, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  confirmRegistration() {
    const device = this.registrationConfirmDevice;
    const template = this.registrationConfirmResultsTemplate;
    const tokenType = this.registrationTokenType;

    if (this.registrationConfirmModalRef != null) {
      this.registrationConfirmModalRef.hide();
    }

    if (this.registrationConfirmMode === 'update') {
      this.performUpdateDeviceRegistration(device, template, tokenType);
    } else {
      this.performRegisterDevice(device, template, tokenType);
    }
  }


  performRegisterDevice(device: Device, template: TemplateRef<any>, tokenType: string) {
    this.deviceService.registerDevice(device.serialNumber, tokenType).subscribe(
      results => {
        if (results != null) {
          this.registrationResults = results;

          device.serialNumber = this.registrationResults.serialNumber;
          device.trustInfo.isRegistered = true;
          device.trustInfo.isTrusted = true;
          device.trustInfo.isVirtual = true;
          device.trustInfo.lastUpdated = moment.utc().toDate();
          device.trustInfo.expireDate = moment().add(13, 'months').toDate();
          device.trustInfo.expireDays = this.calcRegistrationExpireDays(device.trustInfo);

          this.registrationResultsModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
        } else {
          this.toastr.warning('Unable to register this device.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while registering device.');
      });
  }


  trustDevice(device: Device) {
    if (!device.trustInfo.isRegistered) {
      return;
    }

    var newTrust: DeviceRegistrationTrustInfo = {
      comment: '',
      registrationIds: [device.trustInfo.id]
    }

    this.deviceService.trustDevices(newTrust).subscribe(
      results => {
        if (results == null) {
          device.trustInfo.isTrusted = true;
          this.changeLogNotes = '';
          this.createMessageData(MessageActionType.Edited, device, 'Trusted device');
          this.toastr.success('Gateway device is now allowed to access this system');
        } else {
          this.toastr.warning('Unable to trust device');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while trying to trust device');
      });
  }


  untrustDevice(device: Device) {
    if (!device.trustInfo.isTrusted) {
      return;
    }

    var removeTrust: DeviceRegistrationTrustInfo = {
      comment: '',
      registrationIds: [device.trustInfo.id]
    }

    this.deviceService.unTrustDevices(removeTrust).subscribe(
      results => {
        if (results == null) {
          device.trustInfo.isTrusted = false;
          this.changeLogNotes = '';
          this.createMessageData(MessageActionType.Edited, device, 'Untrusted device');
          this.toastr.warning('Gateway device is no longer allowed to access this system');
        } else {
          this.toastr.warning('Unable to untrust device');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while trying to untrust device');
      });
  }


  openBulkChange(template: TemplateRef<any>) {
    this.bulkChangeAction = '';
    this.bulkSelectedUserGroup = undefined;
    this.changeLogNotes = '';
    this.bulkChangeModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  executeBulkChange() {
    this.bulkChangeModalRef.hide();

    const selected = this.devices.filter(x => x.checked);
    if (selected.length < 1) {
      return;
    }

    switch (this.bulkChangeAction) {
      case 'Delete':
        this.bulkDeleteDevices(selected);
        break;
      case 'ChangeOwnership':
        this.bulkChangeOwnership(selected);
        break;
      case 'Trust':
        this.bulkSetTrust(selected, true);
        break;
      case 'Untrust':
        this.bulkSetTrust(selected, false);
        break;
      default:
        break;
    }
  }


  private clearDeviceSelection(devices: Device[]) {
    devices.forEach(d => d.checked = false);
    this.deviceCheckedChanged();
  }


  bulkDeleteDevices(selected: Device[]) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the ' + selected.length + ' selected gateway(s)? This cannot be undone.',
      key: 'cd1',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const selectedIds = selected.map(d => d.id);
        forkJoin(selected.map(d => this.deviceService.removeDevice(d.id, this.username))).subscribe(
          () => {
            selected.forEach(d => this.createMessageData(MessageActionType.Deleted, d, ''));
            this.removeDevicesLocally(selectedIds);
            this.toastr.success('Deleted ' + selected.length + ' gateway(s)');
          },
          err => {
            // Some of the deletes may have succeeded, so reload to show what is really there
            this.reloadAllDevices();
            this.toastr.error('Error occurred while deleting the selected gateways.');
          });
      },
      reject: () => { }
    });
  }


  bulkChangeOwnership(selected: Device[]) {
    const group = this.bulkSelectedUserGroup;
    if (group == undefined) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Change ownership of the ' + selected.length + ' selected gateway(s) to "' + group.name + '"?',
      key: 'cd1',
      header: 'Change Ownership Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        selected.forEach(d => {
          d.userGroupId = group.id;
          d.userGroup = group.name;
        });
        const selectedIds = selected.map(d => d.id);
        const updates = selected.map(d => this.deviceService.updateDevice(this.deviceMapping.mapDevice2DeviceInfo(d), this.username));
        forkJoin(updates).subscribe(
          () => {
            selected.forEach(d => this.createMessageData(MessageActionType.Edited, d, 'Ownership changed to ' + group.name));
            this.refreshAfterSave(selectedIds, false);
            this.toastr.success('Changed ownership of ' + selected.length + ' gateway(s) to ' + group.name);
          },
          err => {
            // Some of the updates may have succeeded, and the rows were changed in memory above, so reload to show what is really there
            this.reloadAllDevices();
            this.toastr.error('Error occurred while changing ownership of the selected gateways.');
          });
      },
      reject: () => { }
    });
  }


  bulkSetTrust(selected: Device[], trust: boolean) {
    const eligible = trust
      ? selected.filter(d => d.trustInfo != undefined && d.trustInfo.isRegistered)
      : selected.filter(d => d.trustInfo != undefined && d.trustInfo.isTrusted);

    if (eligible.length < 1) {
      this.toastr.warning(trust ? 'None of the selected gateways are registered and eligible to trust.'
                                : 'None of the selected gateways are currently trusted.');
      return;
    }

    const actionLabel = trust ? 'trust' : 'untrust';
    this.confirmationService.confirm({
      message: 'Are you sure you want to ' + actionLabel + ' the ' + eligible.length + ' eligible selected gateway(s)?',
      key: 'cd1',
      header: (trust ? 'Trust' : 'Untrust') + ' Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const trustInfo: DeviceRegistrationTrustInfo = {
          comment: '',
          registrationIds: eligible.map(d => d.trustInfo.id)
        };
        const call = trust ? this.deviceService.trustDevices(trustInfo) : this.deviceService.unTrustDevices(trustInfo);
        call.subscribe(
          results => {
            if (results == null) {
              eligible.forEach(d => {
                d.trustInfo.isTrusted = trust;
                this.createMessageData(MessageActionType.Edited, d, trust ? 'Trusted device' : 'Untrusted device');
              });
              this.toastr.success(eligible.length + ' gateway(s) ' + (trust ? 'trusted' : 'untrusted'));
              this.clearDeviceSelection(selected);
            } else {
              this.toastr.warning('Unable to ' + actionLabel + ' the selected gateways');
            }
          },
          err => {
            this.toastr.error('Error occurred while trying to ' + actionLabel + ' the selected gateways');
          });
      },
      reject: () => { }
    });
  }


  updateDeviceRegistration(device: Device, template: TemplateRef<any>) {
    this.registrationConfirmMode = 'update';
    this.registrationConfirmDevice = device;
    this.registrationConfirmResultsTemplate = template;
    this.registrationTokenType = 'Es256';
    this.registrationConfirmHeader = 'Gateway security registration update confirmation';
    this.registrationConfirmMessage = "This device has a virtual security registration. Press 'Continue' to update the registration. Note, the current token associated with this device will no longer function. You will need to use the newly generated token.";

    this.registrationConfirmModalRef = this.modalService.show(this.registrationConfirmTemplate, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  performUpdateDeviceRegistration(device: Device, template: TemplateRef<any>, tokenType: string) {
    this.deviceService.updateDeviceRegistration(device.serialNumber, tokenType).subscribe(
      results => {
        if (results != null) {
          this.registrationResults = results;

          device.serialNumber = this.registrationResults.serialNumber;
          device.trustInfo.isRegistered = true;
          device.trustInfo.isTrusted = true;
          device.trustInfo.lastUpdated = moment.utc().toDate();
          device.trustInfo.expireDate = moment.utc().toDate();
          this.calcRegistrationExpireDays(device.trustInfo);

          this.registrationResultsModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
        } else {
          this.toastr.warning('Unable to update device  security registration');
        }
        return;
      },
      err => {
        this.toastr.error("Error occurred while updating the device's security registration");
      });
  }


  removeDeviceRegistration(device: Device) {
    if (device.trustInfo.isTrusted) {
      return;
    }

    var regMessage = "";

    if (device.trustInfo.isVirtual) {
      regMessage = "This device has a virtual security registration. Presss 'Continue' to remove the registration. After removal you may register again as a virtual device or let your gateway register itself.";
    }
    else {
      regMessage = "This device has a physical security registration. Presss 'Continue' to remove the registration. After removal you may register again as a virtual device or let your gateway register itself.";
    }

    this.confirmationService.confirm({
      message: regMessage,
      key: 'registration',
      header: 'Gateway security registration removal confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deviceService.removeDeviceRegistration(device.serialNumber).subscribe(
          results => {
            if (results != null) {
              this.toastr.warning('Unable to remove device security registration');
            } else {
              device.trustInfo.isRegistered = false;
              device.trustInfo.isTrusted = false;
              device.trustInfo.isVirtual = false;
              device.trustInfo.expireDays = 3650;
            }
            return;
          },
          err => {
            this.toastr.error("Error occurred while removing the device's security registration");
          });
        },
        reject: () => {
        }
      });
  }


  gatewayCommandSelectionChanged(gatewayCommand: GatewayCommand) {
    if (gatewayCommand != undefined) {
      this.gatewayLiveCommand = gatewayCommand.command;
    }
    else {
      this.gatewayCommandSelected = { name: '', description: '', category: '', command: '' };
      this.gatewayLiveCommand = '';
    }
  }


  createOrUpdateSensorgroup() {
    const params: QuickCreateSensorgroupParams = {
      sensorsDisplayed: JSON.parse(JSON.stringify(this.sensorUUIDsDisplayed)),
      selectedUserGroup: this.selectedUserGroup,
      userGroups: this.userGroups
    };

    this.modalService.show(QuickCreateSensorgroupComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  openGatewayUpdateManager() {
    this.devices.forEach(x => x.checked = false);

    const manageableDevices = this.userIsAdmin
      ? this.devices
      : this.devices.filter(d => d.userFeatureAccess?.['EditDevice'] === true);

    const params: UpgradeManagerParams = {
      devices: manageableDevices
    };

    this.modalService.show(UpgradeManagerComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  cloudFileCheckedChanged() {
    this.selectedCloudFiles = this.availableCloudFiles.filter(x => x.checked == true);
  }


  toggleCheckedCloudFiles() {
    if (this.availableCloudFiles.length < 1 || this.device.userFeatureAccess['EditDevice'] == false) {
      return;
    }

    var newState = !this.availableCloudFiles[0].checked;
    this.availableCloudFiles.forEach(cloudFile => {
      cloudFile.checked = newState;
    });
  }


  fileSelectedForUpload(fileEvent) {
    this.uploadFile(fileEvent);
  }


  uploadFile(files: FileList) {
    if (files.length < 1) return;

    let file: File = files[0];
    var formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name)

    this._fileStorageService.uploadFileToStorage(this.device.serialNumber, formData).subscribe(
      results => {
        this.toastr.success(results);
        this.postGatewayUpdateMessage(this.device.serialNumber, "Uploaded " + file.name);
        this.getCloudStorageFileList(this.device.serialNumber);
      },
      err => {
        this.toastr.error('Error occurred while uploading file');
      });
  }


  onFileDownloadToDesktop(cloudFile: CloudFileStorage, sourceId: string) {
    this._fileStorageService.downloadFileFromStorage(sourceId, cloudFile.name).subscribe(
      results => {
        this.postGatewayUpdateMessage(this.device.serialNumber, "Downloaded " + cloudFile.name + " from cloud storage to desktop");
        this.toastr.success('Completed successfully');
        this.cloudFileCheckedChanged();
      },
      err => {
        this.toastr.error('Error occurred while trying to download this file');
      });
  }


  onFileDownloadCheckedToDesktop() {
    this.selectedCloudFiles.forEach(cloudFile => this.onFileDownloadToDesktop(cloudFile, this.device.serialNumber));
  }


  onFileDownloadToGateway(cloudFile: CloudFileStorage) {
    this.postGatewayUpdateMessage(this.device.serialNumber, "Downloading " + cloudFile.name + " from cloud storage to gateway");
    this.executeLiveCommand(null, `downloadFileFromCloudStorage.sh ${cloudFile.name}`, '', 'Executing download command ...');
    this.cloudFileCheckedChanged();
  }


  onFileDownloadCheckedToGateway() {
    this.selectedCloudFiles.forEach(cloudFile => this.onFileDownloadToGateway(cloudFile));
  }



  onFileDeleteConfirm(cloudFile: CloudFileStorage) {
    this.confirmationService.confirm({
      message: 'Please confirm that you want to delete the file ' + cloudFile.name,
      key: 'cd2',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.postGatewayUpdateMessage(this.device.serialNumber, "Deleted " + cloudFile.name + " from cloud storage");
        this.deleteFileFromStorage(cloudFile, this.device.serialNumber);
        this.cloudFileCheckedChanged();
      },
      reject: () => {
      }
    });
  }


  onFileDeleteCheckedConfirm() {
    this.confirmationService.confirm({
      message: 'Please confirm that you want to delete the selected files',
      key: 'cd2',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.selectedCloudFiles.forEach(cloudFile => {
          this.postGatewayUpdateMessage(this.device.serialNumber, "Deleted " + cloudFile.name + " from cloud storage");
          this.deleteFileFromStorage(cloudFile, this.device.serialNumber);
        });
        this.cloudFileCheckedChanged();
      },
      reject: () => {
      }
    });
  }


  deleteFileFromStorage(cloudFile: CloudFileStorage, sourceId: string) {
    this._fileStorageService.deleteFileFromStorage(sourceId, cloudFile.name).subscribe(
      results => {
        this.toastr.success('Completed successfully');
        this.getCloudStorageFileList(sourceId);
      },
      err => {
        this.toastr.error('Error occurred while trying to delete this file');
      });
  }


  getCloudStorageFileList(sourceId: string) {
    this.loadingCloudStorageFileList = true;

    this._fileStorageService.getListOfFilesForSource(sourceId).subscribe(
      results => {
        this.availableCloudFiles = [];
        results.forEach(x => {
          var cloudFile: CloudFileStorage = {
            id: 0,
            name: x,
            uploadDate: undefined,
            fileCount: 0,
            checked: false
          }
          this.availableCloudFiles.push(cloudFile);
          this.getUploadDate(cloudFile, sourceId);
        });
        this.loadingCloudStorageFileList = false;
      },
      err => {
        this.toastr.error('Error occurred while retrieving list of cloud files');
        this.loadingCloudStorageFileList = true;
      });
  }


  getUploadDate(cloudFile: CloudFileStorage, sourceId: string) {
    this.deviceService.getGatewayActivityMessages(sourceId, 20).subscribe(
      results => {
        var deviceMessageInfos: DeviceMessageInfo[] = results;
        var updateMessage = deviceMessageInfos.find(x => x.message == 'Uploaded ' + cloudFile.name);
        if (updateMessage != undefined) {
          var localDate = moment.utc(updateMessage.createdDate).local().toDate();
          cloudFile.uploadDate = localDate;
        }
      },
      err => {
        this.toastr.error("Error getting gateway update message");
      });
  }


  postGatewayUpdateMessage(sourceId: string, message: string) {
    this.deviceService.postGatewayUpdateMessage(sourceId, message).subscribe(
      results => {
        if (results != undefined && results != '') {
          this.toastr.warning(results);
        }
      },
      err => {
        this.toastr.error("Error posting gateway update message");
      });
  }


  getGatewayActivityMessages(device: Device, count: number) {
    count = (count > 0) ? count : this.gatewayActivityLogCountToRetrieve;
    this.gatewayActivityLogCountToRetrieve = count;

    this.gatewayLogsLoading = true;

    this.deviceService.getGatewayActivityMessages(device.serialNumber, count).subscribe(
      results => {
        var deviceMessageInfos: DeviceMessageInfo[] = results;
        if (deviceMessageInfos.length > 0) {
          device.previousUpdateMessage = device.lastUpdateMessage;
          device.lastUpdateMessage = deviceMessageInfos[0].message;
          deviceMessageInfos.forEach(x => {
            x.createdDate = moment.utc(x.createdDate).local().toDate();
          });
          device.updateMessages = deviceMessageInfos;
        }
        this.gatewayLogsLoading = false;
      },
      err => {
        this.gatewayLogsLoading = false;
        this.toastr.error("Error getting gateway activity messages");
      });
  }


  getGatewayMessagesByDateRange(device: Device) {
    const range = this.gatewayLogDateRange;
    if (!range || range.startDate == null || range.endDate == null) return;   // ignore clear/empty

    // toDate() yields the absolute instant (serialized by HttpClient as a UTC ISO string),
    // matching how gateway messages are stored/compared in UTC. Same convention as getIrrigationStats.
    const criteria = {
      sourceId: device.serialNumber,
      startDate: range.startDate.toDate(),
      endDate: range.endDate.toDate(),
    };

    this.gatewayLogsLoading = true;
    device.updateMessages = [];           // clear the display while the fetch is in flight

    this.deviceService.getGatewayActivityMessagesByDateRange(criteria).subscribe(
      results => {
        const messages: DeviceMessageInfo[] = results.messages ?? [];
        messages.forEach(x => {
          x.createdDate = moment.utc(x.createdDate).local().toDate();
        });
        device.updateMessages = messages;
        this.gatewayLogsLoading = false;

        if (results.totalCount > messages.length) {
          this.toastr.info(`Showing the first ${messages.length} of ${results.totalCount} messages within the date range.`);
        }
      },
      err => {
        this.gatewayLogsLoading = false;
        this.toastr.error("Error getting gateway activity messages");
      });
  }


  showGatewayMessageBox() {
    this.showGatewayMessages = !this.showGatewayMessages;
  }

  
  get filteredDeviceMessages(): DeviceMessageInfo[] {
    if (!this.device.updateMessages) return [];
    if (!this.gatewayLogSearchText) return this.device.updateMessages;
    const search = this.gatewayLogSearchText.toLowerCase();
    return this.device.updateMessages.filter(m =>
      m.message?.toLowerCase().includes(search)
    );
  }

  
  deleteAllGatewayMessages(device: Device) {
    if (!device.updateMessages || device.updateMessages.length === 0) return;
    const count = this.filteredDeviceMessages.length;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete all ' + count + ' filtered gateway logs?',
      key: 'cd2',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const messageIds = this.filteredDeviceMessages.map(m => m.id);
        this.deviceService.deleteGatewayActivityMessages(messageIds).subscribe(
          results => {
            device.updateMessages = [];
            this.gatewayLogSearchText = '';
            this.toastr.success('Logs deleted');
          },
          err => {
            this.toastr.error('Error deleting gateway logs');
          });
      },
      reject: () => {}
    });
  }

  //------------------

  searchGatewaysTextChanged() {
    localStorage.setItem('GatewaySearchBox', this.gatewaySearchText);

    this.devices.forEach(x => x.checked = false);
    this.anyDeviceChecked = false;
    
    var searchResults: Device[] = [];
    const searchLimit = 1000;
    let checkedCount = 0;

    if (this.gatewaySearchText == undefined || this.gatewaySearchText == '' || this.gatewaySearchText == 'null') {
      searchResults = [];
    }
    else if (this.gatewaySearchText == '*') {
      searchResults = this.devices;
    }
    else {
      this.gatewaySearchText = this.gatewaySearchText.toLowerCase();
      searchResults = this.devices.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.gatewaySearchText) : false) ||
                                                (s.serialNumber != undefined ? s.serialNumber.toLowerCase().includes(this.gatewaySearchText) : false) ||
                                                (s.macAddress != undefined ? s.macAddress.toLowerCase().includes(this.gatewaySearchText) : false) ||
                                                (s.owner != undefined ? s.owner.toLowerCase().includes(this.gatewaySearchText) : false) ||
                                                (s.description != undefined ? s.description.toLowerCase().includes(this.gatewaySearchText) : false));
    }

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    var deviceIds = searchResults.slice(0, displayCount).map(x => x.id);
    this.devicesDisplayed = this.devices.filter(x => deviceIds.includes(x.id) && x.userFeatureAccess['ViewListing']);

    this.devicesDisplayed.sort((a, b) => {
      if (b.name > a.name) {
        return -1;
      }
      if (b.name < a.name) {
        return 1;
      }
    }); 

    this.deviceCheckedChanged();
  }

  
  clearSearchFilter(): void {
    this.gatewaySearchText = '';
    this.searchGatewaysTextChanged();
  }


  // Search text passed in by a link (e.g. from the home page search), used once in place of the saved search
  private linkedSearch: string | null = null;


  startTimer4RecallLastSearchFilter(): void {
    this.searchRecallTimer = setTimeout(() => {
      this.gatewaySearchText = this.linkedSearch ?? localStorage.getItem('GatewaySearchBox');
      this.linkedSearch = null;
      if (this.gatewaySearchText == undefined || this.gatewaySearchText == 'null') this.gatewaySearchText = "";
      this.searchGatewaysTextChanged();
    },500);
  }

  showSensorsAssociations() {
    const params: SensorAssociationsParams = {
      sensors: this.sensorUUIDsDisplayed.filter(x => x.checked),
    };

    this.modalService.show(SensorAssociationsModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  getLastSensorReadingDatesForSensors(sensors: Sensor[]) {
    var unloadedSensorList = sensors.filter(x => x.lastReading != undefined && !x.lastReading.isLoaded && !x.lastReading.waitingForLoad);

    if (unloadedSensorList.length < 1) {
      return;
    }

    var sensorIds = unloadedSensorList.map(y => y.id);

    unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = true);

    this._sensorService.getLastSensorReadings(sensorIds).subscribe(results => {

      if (results != null) {
        var lastReadings: LastSensorReading[] = results;

        lastReadings.forEach(x => {
          var sensor = unloadedSensorList.find(y => y.id == x.sensorId);

          if (sensor != undefined) {
            sensor.lastReading.date = moment.utc(x.date).toDate();
            sensor.lastReading.isLoaded = true;
            sensor.lastReading.waitingForLoad = false;
            sensor.lastReading.displayColor = this.common.getColorCodeForLastReadingDate(sensor.lastReading.date);
          }
        });
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
      }
      else {
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
        this.toastr.warning('Failed to retrieve last sensor readings info');
      }
    });
  }


  toggleCheckedDevicesDisplayed() {
    if (this.devicesDisplayed == undefined || this.devicesDisplayed.length < 1) {
      return;
    }

    var newState = !this.devicesDisplayed[0].checked;
    this.devicesDisplayed.forEach(device => {
      if (device.userFeatureAccess['EditDevice'] == true) {
        device.checked = newState;
      }
    });

    this.deviceCheckedChanged();
  }


  showSelectedDevices() {
    this.devicesDisplayed = this.devices.filter(x => x.checked);
  }


  deviceCheckedChanged()
  {
    this.anyDeviceChecked = this.devicesDisplayed.some(x => x.checked);
    this.devicesCheckedCount = this.devices.filter(x => x.checked).length;
  }


  irrigationStats() {
    const params: IrrigationStatsParams = {
      devices: this.devicesDisplayed.filter(x => x.checked)
    };

    this.modalService.show(IrrigationStatsModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  startIotDirectConnection(device: Device, template: TemplateRef<any>) {
    this.startIotListenerOnGateway(device);
    this.iotDirectModalRef = this.registrationResultsModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  iotDirectCommandEntered(command: string) {
    if (command == undefined || command.trim() == '') {
      return;
    }

    if (command.trim().toLowerCase() == 'clear') {
      this.clearIotDirectHistory();
      return;
    }

    this.iotDirectHistory += "# " + command.trim() + "\n";
    this.iotDirectCommand = '';

    this.hubConnection.invoke("Send2IotDevice", this.device.id, command.trim()).catch(err => console.error(err));
  }


  startIotListenerOnGateway(device: Device) {
    if (device == undefined || device.id < 1) {
      return;
    }

    this.clearIotDirectHistory();

    this.iotDirectWaitingForConnection = true;
    this.toastr.success('Starting direct connection');

    this.deviceService.startDirectConnection(device.id).subscribe(
      results => {
        this.iotDirectWaitingForConnection = false;
        this.toastr.success('Connection started'); 
      });
  }


  clearIotDirectHistory() {
    this.iotDirectHistory = "# " + "\n";
    this.iotDirectCommand = '';
  }


  populateGatewayListFromSensorGroup(template: TemplateRef<any>) {
    this.loadingSensorGroups = true;

    this._sensorGroupService.getSensorGroupsWithSensors().subscribe(
      results => {
        if (results != null) {
          this.allSensorGroups = results;
          this.sensorGroupsDisplayed = this.allSensorGroups;
          this.loadingSensorGroups = false;
        } else {
          this.toastr.warning('No sensor groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving list of sensor groups.');
      });

    this.sensorGroupsModalRef = this.registrationResultsModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false });
  }


  removeUncheckedGatewaySensorList() {
    this.sensorUUIDsDisplayed = this.sensorUUIDsDisplayed.filter(s => s.checked);
  }


  removeAllGatewaySensorList() {
    this.allSensors.forEach(s => s.checked = false);
    this.sensorUUIDsDisplayed = [];
  }


  toggleCheckedSensorsDisplayed() {
    if (this.sensorUUIDsDisplayed == undefined || this.sensorUUIDsDisplayed.length < 1) {
      return;
    }

    var newState = !this.sensorUUIDsDisplayed[0].checked;
    this.sensorUUIDsDisplayed.forEach(sensor => {
      if (sensor.source != SensorSource.Internal) {
        sensor.checked = newState;
      }
    });
  }


  addSensorGroupSensorsToGatewayList(sensorGroup: SensorGroup) {
    if (sensorGroup == undefined || sensorGroup.sensors == undefined || sensorGroup.sensors.length < 1) {
      return;
    }

    sensorGroup.sensors.forEach(s => {
      var sensor = this.allSensors.find(x => x.id == s.id);
      if (sensor != undefined) {
        sensor.checked = true;
        this.sensorUUIDsDisplayed.push(sensor);
      }
    });
  }


  searchSensorGroupTextChanged() {
    if (this.sensorGroupSearchText == undefined || this.sensorGroupSearchText == '' || this.sensorGroupSearchText == 'null') {
      this.sensorGroupsDisplayed = this.allSensorGroups;
      return;
    }

    this.sensorGroupsDisplayed = this.allSensorGroups.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.sensorGroupSearchText.toLowerCase()) : false) ||
                                                      (s.description != undefined ? s.description.toLowerCase().includes(this.sensorGroupSearchText.toLowerCase()) : false));
  }


  sensorHasBlinkNowCapability(sensor: Sensor): boolean {
    if (sensor.type == undefined || sensor.type == '') {
      return false;
    }

    var sensorTypeName = sensor.type.toLowerCase();

    if (sensorTypeName == "miflora") {
      return true;
    }
    return false;
  }


  blinkSensorNow(sensor: Sensor) {
    this._sensorService.blinkSensor(sensor.id).subscribe(
      results => {
        if (results != null) {
          this.toastr.warning('Success:  Sensor should be blinking now if it is connected and within range.');
        }
        else {
          if (sensor.type.toLowerCase() != "miflora") {
            this.toastr.warning('Request timed out, gateway could not be located, or the sensor did not respond.');
          }
        }
      },
      err => {
        this.toastr.error('Error occurred while locating or connecting to the sensor');
      });
  }

  
}
